export const countries = [
    {
        iso: 'US',
        phone: '1',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AL: 'Alabama' },
                        { AK: 'Alaska' },
                        { AZ: 'Arizona' },
                        { AR: 'Arkansas' },
                        { CA: 'California' },
                        { CO: 'Colorado' },
                        { CT: 'Connecticut' },
                        { DE: 'Delaware' },
                        { DC: 'District Of Columbia' },
                        { FL: 'Florida' },
                        { GA: 'Georgia' },
                        { HI: 'Hawaii' },
                        { ID: 'Idaho' },
                        { IL: 'Illinois' },
                        { IN: 'Indiana' },
                        { IA: 'Iowa' },
                        { KS: 'Kansas' },
                        { KY: 'Kentucky' },
                        { LA: 'Louisiana' },
                        { ME: 'Maine' },
                        { MD: 'Maryland' },
                        { MA: 'Massachusetts' },
                        { MI: 'Michigan' },
                        { MN: 'Minnesota' },
                        { MS: 'Mississippi' },
                        { MO: 'Missouri' },
                        { MT: 'Montana' },
                        { NE: 'Nebraska' },
                        { NV: 'Nevada' },
                        { NH: 'New Hampshire' },
                        { NJ: 'New Jersey' },
                        { NM: 'New Mexico' },
                        { NY: 'New York' },
                        { NC: 'North Carolina' },
                        { ND: 'North Dakota' },
                        { OH: 'Ohio' },
                        { OK: 'Oklahoma' },
                        { OR: 'Oregon' },
                        { PA: 'Pennsylvania' },
                        { RI: 'Rhode Island' },
                        { SC: 'South Carolina' },
                        { SD: 'South Dakota' },
                        { TN: 'Tennessee' },
                        { TX: 'Texas' },
                        { UT: 'Utah' },
                        { VT: 'Vermont' },
                        { VA: 'Virginia' },
                        { WA: 'Washington' },
                        { WV: 'West Virginia' },
                        { WI: 'Wisconsin' },
                        { WY: 'Wyoming' },
                    ],
                },
            },
            {
                postalcode: {
                    label: 'ZIP Code',
                    format: '^\\d{5}(?:[-\\s]\\d{4})?$',
                    eg: '98103',
                },
            },
        ],
        name: 'United States',
    },
    {
        iso: 'AF',
        phone: '93',
        address: [
            { localityname: { label: 'City' } },
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '1001' } },
        ],
        name: 'Afghanistan',
    },
    {
        iso: 'AX',
        phone: '358',
        address: [
            { localityname: { label: 'City' } },
            {
                postalcode: { label: 'Postal Code', format: '^22\\d{3}$', eg: '22150' },
            },
        ],
        name: 'Aland Islands',
    },
    {
        iso: 'AL',
        phone: '355',
        address: [{ localityname: { label: 'City' } }],
        name: 'Albania',
    },
    {
        iso: 'DZ',
        phone: '213',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Algeria',
    },
    {
        iso: 'AS',
        phone: '1684',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'ZIP Code' } }],
        name: 'American Samoa',
    },
    {
        iso: 'AD',
        phone: '376',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Andorra',
    },
    {
        iso: 'AO',
        phone: '244',
        address: [{ localityname: { label: 'City' } }],
        name: 'Angola',
    },
    {
        iso: 'AI',
        phone: '1264',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Anguilla',
    },
    {
        iso: 'AQ',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Antarctica',
    },
    {
        iso: 'AG',
        phone: '1268',
        address: [{ localityname: { label: 'City' } }],
        name: 'Antigua and Barbuda',
    },
    {
        iso: 'AR',
        phone: '54',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?$',
                    eg: 'B1921',
                },
            },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { B: 'Buenos Aires' },
                        { K: 'Catamarca' },
                        { H: 'Chaco' },
                        { U: 'Chubut' },
                        { C: 'Ciudad de Buenos Aires' },
                        { X: 'Córdoba' },
                        { W: 'Corrientes' },
                        { E: 'Entre Ríos' },
                        { P: 'Formosa' },
                        { Y: 'Jujuy' },
                        { L: 'La Pampa' },
                        { F: 'La Rioja' },
                        { M: 'Mendoza' },
                        { N: 'Misiones' },
                        { Q: 'Neuquén' },
                        { R: 'Río Negro' },
                        { A: 'Salta' },
                        { J: 'San Juan' },
                        { D: 'San Luis' },
                        { Z: 'Santa Cruz' },
                        { S: 'Santa Fe' },
                        { G: 'Santiago del Estero' },
                        { V: 'Tierra del Fuego' },
                        { T: 'Tucumán' },
                    ],
                },
            },
        ],
        name: 'Argentina',
    },
    {
        iso: 'AM',
        phone: '374',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Aragatsotn' },
                        { AA: 'Ararat' },
                        { AA: 'Armavir' },
                        { AA: 'Gegharkunik' },
                        { AA: 'Kotayk' },
                        { AA: 'Lori' },
                        { AA: 'Shirak' },
                        { AA: 'Syunik' },
                        { AA: 'Tavush' },
                        { AA: 'Vayots Dzor' },
                        { AA: 'Yerevan' },
                    ],
                },
            },
        ],
        name: 'Armenia',
    },
    {
        iso: 'AW',
        phone: '297',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Aruba',
    },
    {
        iso: 'AU',
        phone: '61',
        address: [
            { localityname: { label: 'City/suburb' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { ACT: 'Australian Capital Territory' },
                        { NSW: 'New South Wales' },
                        { NT: 'Northern Territory' },
                        { QLD: 'Queensland' },
                        { SA: 'South Australia' },
                        { TAS: 'Tasmania' },
                        { VIC: 'Victoria' },
                        { WA: 'Western Australia' },
                    ],
                },
            },
            { postalcode: { label: 'Postcode', format: '^\\d{4}$', eg: '2000' } },
        ],
        name: 'Australia',
    },
    {
        iso: 'AT',
        phone: '43',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '3741' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Austria',
    },
    {
        iso: 'AZ',
        phone: '994',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Azerbaijan',
    },
    {
        iso: 'BS',
        phone: '1242',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [
                        { AA: 'Acklins' },
                        { AA: 'Berry Islands' },
                        { AA: 'Bimini' },
                        { AA: 'Black Point' },
                        { AA: 'Cat Island' },
                        { AA: 'Central Abaco' },
                        { AA: 'Central Andros' },
                        { AA: 'Central Eleuthera' },
                        { AA: 'City of Freeport' },
                        { AA: 'Crooked Island' },
                        { AA: 'East Grand Bahama' },
                        { AA: 'Exuma' },
                        { AA: 'Grand Cay' },
                        { AA: 'Green Turtle Cay' },
                        { AA: 'Harbour Island' },
                        { AA: 'Hope Town' },
                        { AA: 'Inagua' },
                        { AA: 'Long Island' },
                        { AA: 'Mangrove Cay' },
                        { AA: 'Mayaguana' },
                        { AA: "Moore's Island" },
                        { AA: 'North Abaco' },
                        { AA: 'North Andros' },
                        { AA: 'North Eleuthera' },
                        { AA: 'Ragged Island' },
                        { AA: 'Rum Cay' },
                        { AA: 'San Salvador' },
                        { AA: 'South Abaco' },
                        { AA: 'South Andros' },
                        { AA: 'South Eleuthera' },
                        { AA: 'Spanish Wells' },
                        { AA: 'West Grand Bahama' },
                    ],
                },
            },
        ],
        name: 'Bahamas',
    },
    {
        iso: 'BH',
        phone: '973',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Bahrain',
    },
    {
        iso: 'BD',
        phone: '880',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Bangladesh',
    },
    {
        iso: 'BB',
        phone: '1246',
        address: [{ localityname: { label: 'City' } }],
        name: 'Barbados',
    },
    {
        iso: 'BY',
        phone: '375',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Minsk' },
                        { AA: 'Brest' },
                        { AA: 'Homyel' },
                        { AA: 'Hrodna' },
                        { AA: 'Mahilyow' },
                        { AA: 'Minsk' },
                        { AA: 'Vitsebsk' },
                    ],
                },
            },
        ],
        name: 'Belarus',
    },
    {
        iso: 'BE',
        phone: '32',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '4000' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Belgium',
    },
    {
        iso: 'BZ',
        phone: '501',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AA: 'Belize' },
                        { AA: 'Cayo' },
                        { AA: 'Corozal' },
                        { AA: 'Orange Walk' },
                        { AA: 'Stann Creek' },
                        { AA: 'Toledo' },
                    ],
                },
            },
        ],
        name: 'Belize',
    },
    {
        iso: 'BJ',
        phone: '229',
        address: [{ localityname: { label: 'City' } }],
        name: 'Benin',
    },
    {
        iso: 'BM',
        phone: '1441',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Bermuda',
    },
    {
        iso: 'BT',
        phone: '975',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Bhutan',
    },
    {
        iso: 'BO',
        phone: '591',
        address: [{ localityname: { label: 'City' } }],
        name: 'Bolivia',
    },
    {
        iso: 'BA',
        phone: '387',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Bosnia and Herzegovina',
    },
    {
        iso: 'BW',
        phone: '267',
        address: [{ localityname: { label: 'City' } }],
        name: 'Botswana',
    },
    {
        iso: 'BV',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Bouvet Island',
    },
    {
        iso: 'BR',
        phone: '55',
        address: [
            { dependent_localityname: { label: 'Neighborhood' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AC: 'Acre' },
                        { AL: 'Alagoas' },
                        { AM: 'Amazonas' },
                        { AP: 'Amapa' },
                        { BA: 'Bahia' },
                        { CE: 'Ceara' },
                        { DF: 'Distrito Federal' },
                        { ES: 'Espirito Santo' },
                        { GO: 'Goias' },
                        { MA: 'Maranhao' },
                        { MG: 'Minas Gerais' },
                        { MS: 'Mato Grosso do Sul' },
                        { MT: 'Mato Grosso' },
                        { PA: 'Para' },
                        { PB: 'Paraiba' },
                        { PE: 'Pernambuco' },
                        { PI: 'Piaui' },
                        { PR: 'Parana' },
                        { RJ: 'Rio de Janeiro' },
                        { RN: 'Rio Grande do Norte' },
                        { RO: 'Rondonia' },
                        { RR: 'Roraima' },
                        { RS: 'Rio Grande do Sul' },
                        { SC: 'Santa Catarina' },
                        { SE: 'Sergipe' },
                        { SP: 'Sao Paulo' },
                        { TO: 'Tocantins' },
                    ],
                },
            },
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{5}[\\-]?\\d{3}$',
                    eg: '10025-345',
                },
            },
        ],
        name: 'Brazil',
    },
    {
        iso: 'IO',
        phone: '246',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'British Indian Ocean Territory',
    },
    {
        iso: 'VG',
        phone: '1284',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'British Virgin Islands',
    },
    {
        iso: 'BN',
        phone: '673',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Brunei',
    },
    {
        iso: 'BG',
        phone: '359',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Bulgaria',
    },
    {
        iso: 'BF',
        phone: '226',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Burkina Faso',
    },
    {
        iso: 'BI',
        phone: '257',
        address: [{ localityname: { label: 'City' } }],
        name: 'Burundi',
    },
    {
        iso: 'KH',
        phone: '855',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Cambodia',
    },
    {
        iso: 'CM',
        phone: '237',
        address: [{ localityname: { label: 'City' } }],
        name: 'Cameroon',
    },
    {
        iso: 'CA',
        phone: '1',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AB: 'Alberta' },
                        { BC: 'British Columbia' },
                        { MB: 'Manitoba' },
                        { NB: 'New Brunswick' },
                        { NL: 'Newfoundland' },
                        { NT: 'Northwest Territories' },
                        { NS: 'Nova Scotia' },
                        { NU: 'Nunavut' },
                        { ON: 'Ontario' },
                        { PE: 'Prince Edward Island' },
                        { QC: 'Quebec' },
                        { SK: 'Saskatchewan' },
                        { YT: 'Yukon Territory' },
                    ],
                },
            },
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d$',
                    eg: 'K1A 0B1',
                },
            },
        ],
        name: 'Canada',
    },
    {
        iso: 'CV',
        phone: '238',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [
                        { AA: 'Santiago' },
                        { AA: 'São Vicente' },
                        { AA: 'Santo Antão' },
                        { AA: 'Fogo' },
                        { AA: 'Sal' },
                        { AA: 'São Nicolau' },
                        { AA: 'Brava' },
                        { AA: 'Maio' },
                        { AA: 'Boa Vista' },
                        { AA: 'Santa Luzia' },
                        { AA: 'Cape Verde' },
                    ],
                },
            },
        ],
        name: 'Cape Verde',
    },
    { iso: 'BQ', phone: '599', address: [], name: 'Caribbean Netherlands' },
    {
        iso: 'KY',
        phone: '1345',
        address: [
            { postalcode: { label: 'Postal Code' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [{ AA: 'Cayman Brac' }, { AA: 'Grand Cayman' }, { AA: 'Little Cayman' }],
                },
            },
        ],
        name: 'Cayman Islands',
    },
    {
        iso: 'CF',
        phone: '236',
        address: [{ localityname: { label: 'City' } }],
        name: 'Central African Republic',
    },
    {
        iso: 'TD',
        phone: '235',
        address: [{ localityname: { label: 'City' } }],
        name: 'Chad',
    },
    {
        iso: 'CL',
        phone: '56',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AI: 'Aysén del General Carlos Ibáñez del Campo' },
                        { AN: 'Antofagasta' },
                        { AR: 'Araucanía' },
                        { AP: 'Arica y Parinacota' },
                        { AT: 'Atacama' },
                        { BI: 'Biobío' },
                        { CO: 'Coquimbo' },
                        { LI: "Libertador General Bernardo O'Higgins" },
                        { LL: 'Los Lagos' },
                        { LR: 'Los Ríos' },
                        { MA: 'Magallanes y de la Antártica Chilena' },
                        { ML: 'Maule' },
                        { RM: 'Metropolitana de Santiago' },
                        { TA: 'Tarapacá' },
                        { VS: 'Valparaíso' },
                    ],
                },
            },
        ],
        name: 'Chile',
    },
    {
        iso: 'CN',
        phone: '86',
        address: [
            { dependent_localityname: { label: 'District' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { BJ: 'Beijing' },
                        { SH: 'Shanghai' },
                        { GD: 'Guangdong' },
                        { TJ: 'Tianjin' },
                        { HE: 'Hebei' },
                        { SX: 'Shanxi' },
                        { NM: 'Inner Mongolia' },
                        { LN: 'Liaoning' },
                        { JL: 'Jilin' },
                        { HL: 'Heilongjiang' },
                        { JS: 'Jiangsu' },
                        { ZJ: 'Zhejiang' },
                        { AH: 'Anhui' },
                        { FJ: 'Fujian' },
                        { JX: 'Jiangxi' },
                        { SD: 'Shandong' },
                        { HA: 'Henan' },
                        { HB: 'Hubei' },
                        { HN: 'Hunan' },
                        { GX: 'Guangxi' },
                        { HI: 'Hainan' },
                        { CQ: 'Chongqing' },
                        { SC: 'Sichuan' },
                        { GZ: 'Guizhou' },
                        { YN: 'Yunnan' },
                        { XZ: 'Tibet' },
                        { SN: 'Shaanxi' },
                        { GS: 'Gansu' },
                        { QH: 'Qinghai' },
                        { NX: 'Ningxia Hui' },
                        { XJ: 'Xinjiang Uyghur' },
                    ],
                },
            },
            {
                postalcode: { label: 'Postal Code', format: '^\\d{6}$', eg: '101200' },
            },
        ],
        name: 'China',
    },
    {
        iso: 'CX',
        phone: '61',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Christmas Island',
    },
    {
        iso: 'CC',
        phone: '61',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Cocos (Keeling) Islands',
    },
    {
        iso: 'CO',
        phone: '57',
        address: [{ localityname: { label: 'City' } }],
        name: 'Colombia',
    },
    {
        iso: 'KM',
        phone: '269',
        address: [{ localityname: { label: 'City' } }],
        name: 'Comoros',
    },
    {
        iso: 'CG',
        phone: '242',
        address: [{ localityname: { label: 'City' } }],
        name: 'Congo (Brazzaville)',
    },
    {
        iso: 'CD',
        phone: '243',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Congo (Kinshasa)',
    },
    {
        iso: 'CK',
        phone: '682',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Cook Islands',
    },
    {
        iso: 'CR',
        phone: '506',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Costa Rica',
    },
    {
        iso: 'HR',
        phone: '385',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Croatia',
    },
    {
        iso: 'CU',
        phone: '53',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Cuba',
    },
    {
        iso: 'CW',
        phone: '599',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Curaçao',
    },
    {
        iso: 'CY',
        phone: '357',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Cyprus',
    },
    {
        iso: 'CZ',
        phone: '420',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Czech Republic',
    },
    {
        iso: 'CI',
        phone: '225',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Côte d’Ivoire',
    },
    {
        iso: 'DK',
        phone: '45',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '8660' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Denmark',
    },
    {
        iso: 'DJ',
        phone: '253',
        address: [{ localityname: { label: 'City' } }],
        name: 'Djibouti',
    },
    {
        iso: 'DM',
        phone: '1767',
        address: [{ localityname: { label: 'City' } }],
        name: 'Dominica',
    },
    {
        iso: 'DO',
        phone: '1',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Azua' },
                        { AA: 'Baoruco' },
                        { AA: 'Barahona' },
                        { AA: 'Dajabón' },
                        { AA: 'Distrito Nacional' },
                        { AA: 'Duarte' },
                        { AA: 'El Seibo' },
                        { AA: 'Elías Piña' },
                        { AA: 'Espaillat' },
                        { AA: 'Hato Mayor' },
                        { AA: 'Hermanas Mirabal' },
                        { AA: 'Independencia' },
                        { AA: 'La Altagracia' },
                        { AA: 'La Romana' },
                        { AA: 'La Vega' },
                        { AA: 'María Trinidad Sánchez' },
                        { AA: 'Monseñor Nouel' },
                        { AA: 'Monte Cristi' },
                        { AA: 'Monte Plata' },
                        { AA: 'Pedernales' },
                        { AA: 'Peravia' },
                        { AA: 'Puerto Plata' },
                        { AA: 'Samaná' },
                        { AA: 'San Cristóbal' },
                        { AA: 'San José de Ocoa' },
                        { AA: 'San Juan' },
                        { AA: 'San Pedro de Macorís' },
                        { AA: 'Sánchez Ramírez' },
                        { AA: 'Santiago' },
                        { AA: 'Santiago Rodríguez' },
                        { AA: 'Santo Domingo' },
                        { AA: 'Valverde' },
                    ],
                },
            },
        ],
        name: 'Dominican Republic',
    },
    {
        iso: 'EC',
        phone: '593',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Ecuador',
    },
    {
        iso: 'EG',
        phone: '20',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Governorate',
                    options: [
                        { ALX: 'Alexandria' },
                        { ASN: 'Aswan' },
                        { AST: 'Asyut' },
                        { BH: 'Beheira' },
                        { BNS: 'Beni Suef' },
                        { C: 'Cairo' },
                        { DK: 'Dakahlia' },
                        { DT: 'Damietta' },
                        { FYM: 'Faiyum' },
                        { GH: 'Gharbia' },
                        { GZ: 'Giza' },
                        { IS: 'Ismailia' },
                        { KFS: 'Kafr el-Sheikh' },
                        { MT: 'Matruh' },
                        { MN: 'Minya' },
                        { MNF: 'Monufia' },
                        { WAD: 'New Valley' },
                        { SIN: 'North Sinai' },
                        { PTS: 'Port Said' },
                        { KB: 'Qalyubia' },
                        { KN: 'Qena' },
                        { BA: 'Red Sea' },
                        { SHR: 'Sharqia' },
                        { SHG: 'Sohag' },
                        { JS: 'South Sinai' },
                        { SUZ: 'Suez' },
                        { LX: 'Luxor' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Egypt',
    },
    {
        iso: 'SV',
        phone: '503',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Department',
                    options: [
                        { AA: 'Ahuachapán' },
                        { AA: 'Cabañas' },
                        { AA: 'Chalatenango' },
                        { AA: 'Cuscatlán' },
                        { AA: 'La Libertad' },
                        { AA: 'La Paz' },
                        { AA: 'La Unión' },
                        { AA: 'Morazán' },
                        { AA: 'San Miguel' },
                        { AA: 'San Salvador' },
                        { AA: 'San Vicente' },
                        { AA: 'Santa Ana' },
                        { AA: 'Sonsonate' },
                        { AA: 'Usulután' },
                    ],
                },
            },
        ],
        name: 'El Salvador',
    },
    {
        iso: 'GQ',
        phone: '240',
        address: [{ localityname: { label: 'City' } }],
        name: 'Equatorial Guinea',
    },
    {
        iso: 'ER',
        phone: '291',
        address: [{ localityname: { label: 'City' } }],
        name: 'Eritrea',
    },
    {
        iso: 'EE',
        phone: '372',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Estonia',
    },
    {
        iso: 'ET',
        phone: '251',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Ethiopia',
    },
    {
        iso: 'FK',
        phone: '500',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Falkland Islands',
    },
    {
        iso: 'FO',
        phone: '298',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Faroe Islands',
    },
    {
        iso: 'FJ',
        phone: '679',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Ba' },
                        { AA: 'Bua' },
                        { AA: 'Cakaudrove' },
                        { AA: 'Kadavu' },
                        { AA: 'Lau' },
                        { AA: 'Lomaiviti' },
                        { AA: 'Macuata' },
                        { AA: 'Nadroga-Navosa' },
                        { AA: 'Naitasiri' },
                        { AA: 'Namosi' },
                        { AA: 'Ra' },
                        { AA: 'Rewa' },
                        { AA: 'Serua' },
                        { AA: 'Tailevu' },
                    ],
                },
            },
        ],
        name: 'Fiji',
    },
    {
        iso: 'FI',
        phone: '358',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{5}$', eg: '00550' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Finland',
    },
    {
        iso: 'FR',
        phone: '33',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{2}[ ]?\\d{3}$',
                    eg: '75002',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'France',
    },
    {
        iso: 'GF',
        phone: '594',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78]3\\d{2}$',
                    eg: '97300',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'French Guiana',
    },
    {
        iso: 'PF',
        phone: '689',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [
                        { AA: 'Ahē' },
                        { AA: 'Bora Bora' },
                        { AA: "Hiva 'Oa" },
                        { AA: 'Huahine' },
                        { AA: "Mai'ao" },
                        { AA: 'Maupiti' },
                        { AA: "Meheti'a" },
                        { AA: "Mo'orea" },
                        { AA: 'Nuku Hiva' },
                        { AA: 'Raiatea' },
                        { AA: "Taha'a" },
                        { AA: 'Tahiti' },
                        { AA: 'Tetiaroa' },
                        { AA: "Tupua'i" },
                        { AA: 'Tūpai' },
                    ],
                },
            },
        ],
        name: 'French Polynesia',
    },
    {
        iso: 'TF',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'French Southern Territories',
    },
    {
        iso: 'GA',
        phone: '241',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Gabon',
    },
    {
        iso: 'GM',
        phone: '220',
        address: [{ localityname: { label: 'City' } }],
        name: 'Gambia',
    },
    {
        iso: 'GE',
        phone: '995',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Georgia',
    },
    {
        iso: 'DE',
        phone: '49',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{5}$', eg: '60322' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Germany',
    },
    {
        iso: 'GH',
        phone: '233',
        address: [{ localityname: { label: 'City' } }],
        name: 'Ghana',
    },
    {
        iso: 'GI',
        phone: '350',
        address: [{ postalcode: { label: 'Postal Code' } }],
        name: 'Gibraltar',
    },
    {
        iso: 'GR',
        phone: '30',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{3} ?\\d{2}$',
                    eg: '151 24',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Greece',
    },
    {
        iso: 'GL',
        phone: '299',
        address: [
            {
                postalcode: { label: 'Postal Code', format: '^39\\d{2}$', eg: '3911' },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Greenland',
    },
    {
        iso: 'GD',
        phone: '1473',
        address: [{ localityname: { label: 'City' } }],
        name: 'Grenada',
    },
    {
        iso: 'GP',
        phone: '590',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78][01]\\d{2}$',
                    eg: '97100',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Guadeloupe',
    },
    {
        iso: 'GU',
        phone: '1671',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'ZIP Code' } }],
        name: 'Guam',
    },
    {
        iso: 'GT',
        phone: '502',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Guatemala',
    },
    {
        iso: 'GG',
        phone: '44',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^GY\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$',
                    eg: 'GY1 1AA',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Guernsey',
    },
    {
        iso: 'GN',
        phone: '224',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Guinea',
    },
    {
        iso: 'GW',
        phone: '245',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Guinea-Bissau',
    },
    {
        iso: 'GY',
        phone: '592',
        address: [{ localityname: { label: 'City' } }],
        name: 'Guyana',
    },
    {
        iso: 'HT',
        phone: '509',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Haiti',
    },
    {
        iso: 'HM',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Heard Island and McDonald Islands',
    },
    {
        iso: 'HN',
        phone: '504',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Department',
                    options: [
                        { AA: 'Atlántida' },
                        { AA: 'Choluteca' },
                        { AA: 'Colón' },
                        { AA: 'Comayagua' },
                        { AA: 'Copán' },
                        { AA: 'Cortés' },
                        { AA: 'El Paraíso' },
                        { AA: 'Francisco Morazán' },
                        { AA: 'Gracias a Dios' },
                        { AA: 'Intibucá' },
                        { AA: 'Islas de la Bahía' },
                        { AA: 'La Paz' },
                        { AA: 'Lempira' },
                        { AA: 'Ocotepeque' },
                        { AA: 'Olancho' },
                        { AA: 'Santa Bárbara' },
                        { AA: 'Valle' },
                        { AA: 'Yoro' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Honduras',
    },
    {
        iso: 'HK',
        phone: '852',
        address: [
            { localityname: { label: 'District' } },
            {
                administrativearea: {
                    label: 'Area',
                    options: [
                        { Kowloon: 'Kowloon' },
                        { 'Hong Kong Island': 'Hong Kong Island' },
                        { 'New Territories': 'New Territories' },
                    ],
                },
            },
        ],
        name: 'Hong Kong',
    },
    {
        iso: 'HU',
        phone: '36',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Hungary',
    },
    {
        iso: 'IS',
        phone: '354',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Iceland',
    },
    {
        iso: 'IN',
        phone: '91',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AP: 'Andhra Pradesh' },
                        { AR: 'Arunachal Pradesh' },
                        { AS: 'Assam' },
                        { BR: 'Bihar' },
                        { CT: 'Chhattisgarh' },
                        { GA: 'Goa' },
                        { GJ: 'Gujarat' },
                        { HR: 'Haryana' },
                        { HP: 'Himachal Pradesh' },
                        { JK: 'Jammu and Kashmir' },
                        { JH: 'Jharkhand' },
                        { KA: 'Karnataka' },
                        { KL: 'Kerala' },
                        { MP: 'Madhya Pradesh' },
                        { MH: 'Maharashtra' },
                        { MN: 'Manipur' },
                        { ML: 'Meghalaya' },
                        { MZ: 'Mizoram' },
                        { NL: 'Nagaland' },
                        { OR: 'Odisha' },
                        { PB: 'Punjab' },
                        { RJ: 'Rajasthan' },
                        { SK: 'Sikkim' },
                        { TN: 'Tamil Nadu' },
                        { TR: 'Tripura' },
                        { UP: 'Uttar Pradesh' },
                        { UT: 'Uttarakhand' },
                        { WB: 'West Bengal' },
                        { AN: 'Andaman and Nicobar Islands' },
                        { CH: 'Chandigarh' },
                        { DN: 'Dadra and Nagar Haveli' },
                        { DD: 'Daman and Diu' },
                        { LD: 'Lakshadweep' },
                        { DL: 'National Capital Territory of Delhi' },
                        { PY: 'Puducherry' },
                    ],
                },
            },
            { postalcode: { label: 'PIN code', format: '^\\d{6}$', eg: '110005' } },
        ],
        name: 'India',
    },
    {
        iso: 'ID',
        phone: '62',
        address: [
            { localityname: { label: 'City/regency' } },
            { postalcode: { label: 'Postal Code' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AC: 'Aceh' },
                        { BA: 'Bali' },
                        { BB: 'Bangka Belitung' },
                        { BT: 'Banten' },
                        { BE: 'Bengkulu' },
                        { JK: 'DKI Jakarta' },
                        { YO: 'D.I. Yogyakarta' },
                        { GO: 'Gorontalo' },
                        { JA: 'Jambi' },
                        { JB: 'Jawa Barat' },
                        { JT: 'Jawa Tengah' },
                        { JI: 'Jawa Timur' },
                        { KB: 'Kalimantan Barat' },
                        { KS: 'Kalimantan Selatan' },
                        { KT: 'Kalimantan Tengah' },
                        { KI: 'Kalimantan Timur' },
                        { KR: 'Kepulauan Riau' },
                        { LA: 'Lampung' },
                        { MA: 'Maluku' },
                        { MU: 'Maluku Utara' },
                        { NB: 'Nusa Tenggara Barat' },
                        { NT: 'Nusa Tenggara Timur' },
                        { PA: 'Papua' },
                        { PB: 'Papua Barat' },
                        { RI: 'Riau' },
                        { SR: 'Sulawesi Barat' },
                        { SN: 'Sulawesi Selatan' },
                        { ST: 'Sulawesi Tengah' },
                        { SG: 'Sulawesi Tenggara' },
                        { SA: 'Sulawesi Utara' },
                        { SB: 'Sumatera Barat' },
                        { SS: 'Sumatera Selatan' },
                        { SU: 'Sumatera Utara' },
                    ],
                },
            },
        ],
        name: 'Indonesia',
    },
    {
        iso: 'IR',
        phone: '98',
        address: [
            { dependent_localityname: { label: 'Neighborhood' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Governorate',
                    options: [
                        { AA: 'Alborz' },
                        { AA: 'Ardabil' },
                        { AA: 'Azerbaijan, East' },
                        { AA: 'Azerbaijan, West' },
                        { AA: 'Bushehr' },
                        { AA: 'Chahar Mahaal and Bakhtiari' },
                        { AA: 'Fars' },
                        { AA: 'Gilan' },
                        { AA: 'Golestan' },
                        { AA: 'Hamadan' },
                        { AA: 'Hormozgān' },
                        { AA: 'Ilam' },
                        { AA: 'Isfahan' },
                        { AA: 'Kerman' },
                        { AA: 'Kermanshah' },
                        { AA: 'Khorasan, North' },
                        { AA: 'Khorasan, Razavi' },
                        { AA: 'Khorasan, South' },
                        { AA: 'Khuzestan' },
                        { AA: 'Kohgiluyeh and Boyer-Ahmad' },
                        { AA: 'Kurdistan' },
                        { AA: 'Lorestan' },
                        { AA: 'Markazi' },
                        { AA: 'Mazandaran' },
                        { AA: 'Qazvin' },
                        { AA: 'Qom' },
                        { AA: 'Semnan' },
                        { AA: 'Sistan and Baluchestan' },
                        { AA: 'Tehran' },
                        { AA: 'Yazd' },
                        { AA: 'Zanjan' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Iran',
    },
    {
        iso: 'IQ',
        phone: '964',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Al-Anbar' },
                        { AA: 'Al-Basrah' },
                        { AA: 'Al-Karbalā' },
                        { AA: 'Al-Muthannā' },
                        { AA: 'Al-Qādisiyyah' },
                        { AA: 'An-Najaf' },
                        { AA: 'Arbīl' },
                        { AA: 'As-Sulaymāniyyah' },
                        { AA: 'Baghdād' },
                        { AA: 'Bābil' },
                        { AA: 'Dahūk' },
                        { AA: 'Dhī Qār' },
                        { AA: 'Diyālā' },
                        { AA: 'Kirkuk' },
                        { AA: 'Maysān' },
                        { AA: 'Nīnawā' },
                        { AA: 'Salāh ad-Dīn' },
                        { AA: 'Wāsit' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Iraq',
    },
    {
        iso: 'IE',
        phone: '353',
        address: [
            { localityname: { label: 'Town/city' } },
            {
                administrativearea: {
                    label: 'County',
                    options: [
                        { CW: 'Co Carlow' },
                        { CN: 'Co Cavan' },
                        { CE: 'Co Clare' },
                        { CO: 'Co Cork' },
                        { DL: 'Co Donegal' },
                        { D: 'Co Dublin' },
                        { D1: 'Dublin 1' },
                        { D2: 'Dublin 2' },
                        { D3: 'Dublin 3' },
                        { D4: 'Dublin 4' },
                        { D5: 'Dublin 5' },
                        { D6: 'Dublin 6' },
                        { D6W: 'Dublin 6w' },
                        { D7: 'Dublin 7' },
                        { D8: 'Dublin 8' },
                        { D9: 'Dublin 9' },
                        { D10: 'Dublin 10' },
                        { D11: 'Dublin 11' },
                        { D12: 'Dublin 12' },
                        { D13: 'Dublin 13' },
                        { D14: 'Dublin 14' },
                        { D15: 'Dublin 15' },
                        { D16: 'Dublin 16' },
                        { D17: 'Dublin 17' },
                        { D18: 'Dublin 18' },
                        { D19: 'Dublin 19' },
                        { D20: 'Dublin 20' },
                        { D21: 'Dublin 21' },
                        { D22: 'Dublin 22' },
                        { D23: 'Dublin 23' },
                        { D24: 'Dublin 24' },
                        { G: 'Co Galway' },
                        { KY: 'Co Kerry' },
                        { KE: 'Co Kildare' },
                        { KK: 'Co Kilkenny' },
                        { LS: 'Co Laois' },
                        { LM: 'Co Leitrim' },
                        { LK: 'Co Limerick' },
                        { LD: 'Co Longford' },
                        { LH: 'Co Louth' },
                        { MO: 'Co Mayo' },
                        { MH: 'Co Meath' },
                        { MN: 'Co Monaghan' },
                        { OY: 'Co Offaly' },
                        { RN: 'Co Roscommon' },
                        { SO: 'Co Sligo' },
                        { TA: 'Co Tipperary' },
                        { WD: 'Co Waterford' },
                        { WH: 'Co Westmeath' },
                        { WX: 'Co Wexford' },
                        { WW: 'Co Wicklow' },
                    ],
                },
            },
        ],
        name: 'Ireland',
    },
    {
        iso: 'IM',
        phone: '44',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^IM\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$',
                    eg: 'IM99 1PS',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Isle of Man',
    },
    {
        iso: 'IL',
        phone: '972',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Israel',
    },
    {
        iso: 'IT',
        phone: '39',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AG: 'Agrigento' },
                        { AL: 'Alessandria' },
                        { AN: 'Ancona' },
                        { AO: "Valle d'Aosta/VallÈe d'Aoste" },
                        { AP: 'Ascoli Piceno' },
                        { AQ: "L'Aquila" },
                        { AR: 'Arezzo' },
                        { AT: 'Asti' },
                        { AV: 'Avellino' },
                        { BA: 'Bari' },
                        { BG: 'Bergamo' },
                        { BI: 'Biella' },
                        { BL: 'Belluno' },
                        { BN: 'Benevento' },
                        { BO: 'Bologna' },
                        { BR: 'Brindisi' },
                        { BS: 'Brescia' },
                        { BT: 'Barletta-Andria-Trani' },
                        { BZ: 'Bolzano/Bozen' },
                        { CA: 'Cagliari' },
                        { CB: 'Campobasso' },
                        { CE: 'Caserta' },
                        { CH: 'Chieti' },
                        { CI: 'Carbonia-Iglesias' },
                        { CL: 'Caltanissetta' },
                        { CN: 'Cuneo' },
                        { CO: 'Como' },
                        { CR: 'Cremona' },
                        { CS: 'Cosenza' },
                        { CT: 'Catania' },
                        { CZ: 'Catanzaro' },
                        { EN: 'Enna' },
                        { FC: 'ForlÏ-Cesena' },
                        { FE: 'Ferrara' },
                        { FG: 'Foggia' },
                        { FI: 'Firenze' },
                        { FM: 'Fermo' },
                        { FR: 'Frosinone' },
                        { GE: 'Genova' },
                        { GO: 'Gorizia' },
                        { GR: 'Grosseto' },
                        { IM: 'Imperia' },
                        { IS: 'Isernia' },
                        { KR: 'Crotone' },
                        { LC: 'Lecco' },
                        { LE: 'Lecce' },
                        { LI: 'Livorno' },
                        { LO: 'Lodi' },
                        { LT: 'Latina' },
                        { LU: 'Lucca' },
                        { MB: 'Monza e Brianza' },
                        { MC: 'Macerata' },
                        { ME: 'Messina' },
                        { MI: 'Milano' },
                        { MN: 'Mantova' },
                        { MO: 'Modena' },
                        { MS: 'Massa-Carrara' },
                        { MT: 'Matera' },
                        { NA: 'Napoli' },
                        { NO: 'Novara' },
                        { NU: 'Nuoro' },
                        { OG: 'Ogliastra' },
                        { OR: 'Oristano' },
                        { OT: 'Olbia-Tempio' },
                        { PA: 'Palermo' },
                        { PC: 'Piacenza' },
                        { PD: 'Padova' },
                        { PE: 'Pescara' },
                        { PG: 'Perugia' },
                        { PI: 'Pisa' },
                        { PN: 'Pordenone' },
                        { PO: 'Prato' },
                        { PR: 'Parma' },
                        { PT: 'Pistoia' },
                        { PU: 'Pesaro e Urbino' },
                        { PV: 'Pavia' },
                        { PZ: 'Potenza' },
                        { RA: 'Ravenna' },
                        { RC: 'Reggio di Calabria' },
                        { RE: "Reggio nell'Emilia" },
                        { RG: 'Ragusa' },
                        { RI: 'Rieti' },
                        { RM: 'Roma' },
                        { RN: 'Rimini' },
                        { RO: 'Rovigo' },
                        { SA: 'Salerno' },
                        { SI: 'Siena' },
                        { SO: 'Sondrio' },
                        { SP: 'La Spezia' },
                        { SR: 'Siracusa' },
                        { SS: 'Sassari' },
                        { SV: 'Savona' },
                        { TA: 'Taranto' },
                        { TE: 'Teramo' },
                        { TN: 'Trento' },
                        { TO: 'Torino' },
                        { TP: 'Trapani' },
                        { TR: 'Terni' },
                        { TS: 'Trieste' },
                        { TV: 'Treviso' },
                        { UD: 'Udine' },
                        { VA: 'Varese' },
                        { VB: 'Verbano-Cusio-Ossola' },
                        { VC: 'Vercelli' },
                        { VE: 'Venezia' },
                        { VI: 'Vicenza' },
                        { VR: 'Verona' },
                        { VS: 'Medio Campidano' },
                        { VT: 'Viterbo' },
                        { VV: 'Vibo Valentia' },
                    ],
                },
            },
        ],
        name: 'Italy',
    },
    {
        iso: 'JM',
        phone: '1876',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Parish',
                    options: [
                        { Clarendon: 'Clarendon' },
                        { Hanover: 'Hanover' },
                        { Kingston: 'Kingston' },
                        { Manchester: 'Manchester' },
                        { Portland: 'Portland' },
                        { 'St. Andrew': 'St. Andrew' },
                        { 'St. Ann': 'St. Ann' },
                        { 'St. Catherine': 'St. Catherine' },
                        { 'St. Elizabeth': 'St. Elizabeth' },
                        { 'St. James': 'St. James' },
                        { 'St. Mary': 'St. Mary' },
                        { 'St. Thomas': 'St. Thomas' },
                        { Trelawny: 'Trelawny' },
                        { Westmoreland: 'Westmoreland' },
                    ],
                },
            },
        ],
        name: 'Jamaica',
    },
    {
        iso: 'JP',
        phone: '81',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{3}-?\\d{4}$',
                    eg: '142-0062',
                },
            },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Prefecture',
                    options: [
                        { Hokkaido: 'Hokkaido' },
                        { Aomori: 'Aomori' },
                        { Iwate: 'Iwate' },
                        { Miyagi: 'Miyagi' },
                        { Akita: 'Akita' },
                        { Yamagata: 'Yamagata' },
                        { Fukushima: 'Fukushima' },
                        { Ibaraki: 'Ibaraki' },
                        { Tochigi: 'Tochigi' },
                        { Gunma: 'Gunma' },
                        { Saitama: 'Saitama' },
                        { Chiba: 'Chiba' },
                        { Tokyo: 'Tokyo' },
                        { Kanagawa: 'Kanagawa' },
                        { Niigata: 'Niigata' },
                        { Toyama: 'Toyama' },
                        { Ishikawa: 'Ishikawa' },
                        { Fukui: 'Fukui' },
                        { Yamanashi: 'Yamanashi' },
                        { Nagano: 'Nagano' },
                        { Gifu: 'Gifu' },
                        { Shizuoka: 'Shizuoka' },
                        { Aichi: 'Aichi' },
                        { Mie: 'Mie' },
                        { Shiga: 'Shiga' },
                        { Kyoto: 'Kyoto' },
                        { Osaka: 'Osaka' },
                        { Hyogo: 'Hyogo' },
                        { Nara: 'Nara' },
                        { Wakayama: 'Wakayama' },
                        { Tottori: 'Tottori' },
                        { Shimane: 'Shimane' },
                        { Okayama: 'Okayama' },
                        { Hiroshima: 'Hiroshima' },
                        { Yamaguchi: 'Yamaguchi' },
                        { Tokushima: 'Tokushima' },
                        { Kagawa: 'Kagawa' },
                        { Ehime: 'Ehime' },
                        { Kochi: 'Kochi' },
                        { Fukuoka: 'Fukuoka' },
                        { Saga: 'Saga' },
                        { Nagasaki: 'Nagasaki' },
                        { Kumamoto: 'Kumamoto' },
                        { Oita: 'Oita' },
                        { Miyazaki: 'Miyazaki' },
                        { Kagoshima: 'Kagoshima' },
                        { Okinawa: 'Okinawa' },
                    ],
                },
            },
        ],
        name: 'Japan',
    },
    {
        iso: 'JE',
        phone: '44',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^JE\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}$',
                    eg: 'JE2 2BT',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Jersey',
    },
    {
        iso: 'JO',
        phone: '962',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Governorate',
                    options: [
                        { AA: 'Irbid' },
                        { AA: 'Ajloun' },
                        { AA: 'Jerash' },
                        { AA: 'Mafraq' },
                        { AA: 'Balqa' },
                        { AA: 'Amman' },
                        { AA: 'Zarqa' },
                        { AA: 'Madaba' },
                        { AA: 'Karak' },
                        { AA: 'Tafilah' },
                        { AA: "Ma'an" },
                        { AA: 'Aqaba' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Jordan',
    },
    {
        iso: 'KZ',
        phone: '7',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Region',
                    options: [
                        { AA: 'Akmola' },
                        { AA: 'Aktobe' },
                        { AA: 'Almaty' },
                        { AA: 'Astana' },
                        { AA: 'Atyrau' },
                        { AA: 'Baikonur' },
                        { AA: 'East Kazakhstan' },
                        { AA: 'Jambyl' },
                        { AA: 'Karaganda' },
                        { AA: 'Kostanay' },
                        { AA: 'Kyzylorda' },
                        { AA: 'Mangystau' },
                        { AA: 'North Kazakhstan' },
                        { AA: 'Pavlodar' },
                        { AA: 'South Kazakhstan' },
                        { AA: 'West Kazakhstan' },
                    ],
                },
            },
        ],
        name: 'Kazakhstan',
    },
    {
        iso: 'KE',
        phone: '254',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Kenya',
    },
    {
        iso: 'KI',
        phone: '686',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [
                        { AA: 'Abaiang' },
                        { AA: 'Abariringa' },
                        { AA: 'Abemama' },
                        { AA: 'Aranuka' },
                        { AA: 'Arorae' },
                        { AA: 'Banaba' },
                        { AA: 'Beru' },
                        { AA: 'Birnie Island' },
                        { AA: 'Butaritari' },
                        { AA: 'Caroline Island' },
                        { AA: 'Enderbury Island' },
                        { AA: 'Flint Island' },
                        { AA: 'Kiritimati' },
                        { AA: 'Kuria' },
                        { AA: 'Maiana' },
                        { AA: 'Makin' },
                        { AA: 'Malden Island' },
                        { AA: 'Manra Island' },
                        { AA: 'Marakei' },
                        { AA: 'McKean Island' },
                        { AA: 'Nikumaroro' },
                        { AA: 'Nikunau' },
                        { AA: 'Nonouti' },
                        { AA: 'Onotoa' },
                        { AA: 'Orona' },
                        { AA: 'Rawaki Island' },
                        { AA: 'Starbuck Island' },
                        { AA: 'Tabiteuea' },
                        { AA: 'Tabuaeran' },
                        { AA: 'Tamana' },
                        { AA: 'Tarawa' },
                        { AA: 'Teraina' },
                        { AA: 'Vostok Island' },
                    ],
                },
            },
        ],
        name: 'Kiribati',
    },
    { iso: 'XK', phone: '383', address: [], name: 'Kosovo' },
    {
        iso: 'KW',
        phone: '965',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Governorate',
                    options: [
                        { AA: 'Al Asimah' },
                        { AA: 'Hawalli' },
                        { AA: 'Farwaniya' },
                        { AA: 'Mubarak Al-Kabeer' },
                        { AA: 'Ahmadi' },
                        { AA: 'Jahra' },
                    ],
                },
            },
        ],
        name: 'Kuwait',
    },
    {
        iso: 'KG',
        phone: '996',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Kyrgyzstan',
    },
    {
        iso: 'LA',
        phone: '856',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Laos',
    },
    {
        iso: 'LV',
        phone: '371',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Latvia',
    },
    {
        iso: 'LB',
        phone: '961',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Lebanon',
    },
    {
        iso: 'LS',
        phone: '266',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Lesotho',
    },
    {
        iso: 'LR',
        phone: '231',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Liberia',
    },
    {
        iso: 'LY',
        phone: '218',
        address: [{ localityname: { label: 'City' } }],
        name: 'Libya',
    },
    {
        iso: 'LI',
        phone: '423',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^(948[5-9])|(949[0-7])$',
                    eg: '9496',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Liechtenstein',
    },
    {
        iso: 'LT',
        phone: '370',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Lithuania',
    },
    {
        iso: 'LU',
        phone: '352',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '4750' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Luxembourg',
    },
    {
        iso: 'MO',
        phone: '853',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Macau',
    },
    {
        iso: 'MK',
        phone: '389',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Macedonia',
    },
    {
        iso: 'MG',
        phone: '261',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Madagascar',
    },
    {
        iso: 'MW',
        phone: '265',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Malawi',
    },
    {
        iso: 'MY',
        phone: '60',
        address: [
            { dependent_localityname: { label: 'Village/township' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { Johor: 'Johor' },
                        { Kedah: 'Kedah' },
                        { Kelantan: 'Kelantan' },
                        { 'Kuala Lumpur': 'Kuala Lumpur' },
                        { Labuan: 'Labuan' },
                        { Melaka: 'Melaka' },
                        { 'Negeri Sembilan': 'Negeri Sembilan' },
                        { Pahang: 'Pahang' },
                        { Perak: 'Perak' },
                        { Perlis: 'Perlis' },
                        { 'Pulau Pinang': 'Pulau Pinang' },
                        { Putrajaya: 'Putrajaya' },
                        { Sabah: 'Sabah' },
                        { Sarawak: 'Sarawak' },
                        { Selangor: 'Selangor' },
                        { Terengganu: 'Terengganu' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Malaysia',
    },
    {
        iso: 'MV',
        phone: '960',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Maldives',
    },
    {
        iso: 'ML',
        phone: '223',
        address: [{ localityname: { label: 'City' } }],
        name: 'Mali',
    },
    {
        iso: 'MT',
        phone: '356',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Malta',
    },
    {
        iso: 'MH',
        phone: '692',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AA: 'Ailinglaplap' },
                        { AA: 'Ailuk' },
                        { AA: 'Arno' },
                        { AA: 'Aur' },
                        { AA: 'Ebon' },
                        { AA: 'Enewetok/Ujelang' },
                        { AA: 'Jabat' },
                        { AA: 'Jaluit' },
                        { AA: 'Kili/Bikini/Ejit' },
                        { AA: 'Kwajalein' },
                        { AA: 'Lae' },
                        { AA: 'Lib' },
                        { AA: 'Likiep' },
                        { AA: 'Majuro' },
                        { AA: 'Maloelap' },
                        { AA: 'Mejit' },
                        { AA: 'Mili' },
                        { AA: 'Namorik' },
                        { AA: 'Namu' },
                        { AA: 'Rongelap' },
                        { AA: 'Ujae' },
                        { AA: 'Utirik' },
                        { AA: 'Wotho' },
                        { AA: 'Wotje' },
                    ],
                },
            },
            { postalcode: { label: 'ZIP Code' } },
        ],
        name: 'Marshall Islands',
    },
    {
        iso: 'MQ',
        phone: '596',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78]2\\d{2}$',
                    eg: '97220',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Martinique',
    },
    {
        iso: 'MR',
        phone: '222',
        address: [{ localityname: { label: 'City' } }],
        name: 'Mauritania',
    },
    {
        iso: 'MU',
        phone: '230',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Mauritius',
    },
    {
        iso: 'YT',
        phone: '262',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^976\\d{2}$',
                    eg: '97600',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Mayotte',
    },
    {
        iso: 'MX',
        phone: '52',
        address: [
            { dependent_localityname: { label: 'Neighborhood' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AGU: 'Aguascalientes' },
                        { BCN: 'Baja California' },
                        { BCS: 'Baja California Sur' },
                        { CAM: 'Campeche' },
                        { COA: 'Coahuila' },
                        { COL: 'Colima' },
                        { CHP: 'Chiapas' },
                        { CHH: 'Chihuahua' },
                        { DIF: 'Distrito Federal' },
                        { DUG: 'Durango' },
                        { MEX: 'Estado de México' },
                        { GUA: 'Guanajuato' },
                        { GRO: 'Guerrero' },
                        { HID: 'Hidalgo' },
                        { JAL: 'Jalisco' },
                        { MIC: 'Michoacán' },
                        { MOR: 'Morelos' },
                        { NAY: 'Nayarit' },
                        { NLE: 'Nuevo León' },
                        { OAX: 'Oaxaca' },
                        { PUE: 'Puebla' },
                        { QUE: 'Queretaro' },
                        { ROO: 'Quintana Roo' },
                        { SLP: 'San Luis Potosí' },
                        { SIN: 'Sinaloa' },
                        { SON: 'Sonora' },
                        { TAB: 'Tabasco' },
                        { TAM: 'Tamaulipas' },
                        { TLA: 'Tlaxcala' },
                        { VER: 'Veracruz' },
                        { YUC: 'Yucatán' },
                        { ZAC: 'Zacatecas' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code', format: '^\\d{5}$', eg: '03400' } },
        ],
        name: 'Mexico',
    },
    {
        iso: 'FM',
        phone: '691',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [{ AA: 'Chuuk' }, { AA: 'Kosrae' }, { AA: 'Pohnpei' }, { AA: 'Yap' }],
                },
            },
            { postalcode: { label: 'ZIP Code' } },
        ],
        name: 'Micronesia',
    },
    {
        iso: 'MD',
        phone: '373',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Moldova',
    },
    {
        iso: 'MC',
        phone: '377',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Monaco',
    },
    {
        iso: 'MN',
        phone: '976',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Arkhangai' },
                        { AA: 'Bayankhongor' },
                        { AA: 'Bayan-Ölgii' },
                        { AA: 'Bulgan' },
                        { AA: 'Darkhan-Uul' },
                        { AA: 'Dornod' },
                        { AA: 'Dornogovi' },
                        { AA: 'Dundgovi' },
                        { AA: 'Govi-Altai' },
                        { AA: 'Govisümber' },
                        { AA: 'Khentii' },
                        { AA: 'Khovd' },
                        { AA: 'Khövsgöl' },
                        { AA: 'Orkhon' },
                        { AA: 'Ömnögovi' },
                        { AA: 'Övörkhangai' },
                        { AA: 'Selenge' },
                        { AA: 'Sükhbaatar' },
                        { AA: 'Töv' },
                        { AA: 'Uvs' },
                        { AA: 'Zavkhan' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Mongolia',
    },
    {
        iso: 'ME',
        phone: '382',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Montenegro',
    },
    {
        iso: 'MS',
        phone: '1664',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Montserrat',
    },
    {
        iso: 'MA',
        phone: '212',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Morocco',
    },
    {
        iso: 'MZ',
        phone: '258',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Cabo Delgado' },
                        { AA: 'Gaza' },
                        { AA: 'Inhambane' },
                        { AA: 'Manica' },
                        { AA: 'Maputo City' },
                        { AA: 'Maputo' },
                        { AA: 'Nampula' },
                        { AA: 'Niassa' },
                        { AA: 'Sofala' },
                        { AA: 'Tete' },
                        { AA: 'Zambezia' },
                    ],
                },
            },
        ],
        name: 'Mozambique',
    },
    {
        iso: 'MM',
        phone: '95',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Myanmar',
    },
    {
        iso: 'NA',
        phone: '264',
        address: [{ localityname: { label: 'City' } }],
        name: 'Namibia',
    },
    {
        iso: 'NR',
        phone: '674',
        address: [
            {
                administrativearea: {
                    label: 'District',
                    options: [
                        { AA: 'Aiwo' },
                        { AA: 'Anabar' },
                        { AA: 'Anetan' },
                        { AA: 'Boe' },
                        { AA: 'Buada' },
                        { AA: 'Meneng' },
                        { AA: 'Ubenide' },
                        { AA: 'Yaren' },
                    ],
                },
            },
        ],
        name: 'Nauru',
    },
    {
        iso: 'NP',
        phone: '977',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Nepal',
    },
    {
        iso: 'NL',
        phone: '31',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{4}[ ]?[A-Z]{2}$',
                    eg: '2585 GJ',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Netherlands',
    },
    {
        iso: 'AN',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Netherlands Antilles',
    },
    {
        iso: 'NC',
        phone: '687',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^988\\d{2}$',
                    eg: '98814',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'New Caledonia',
    },
    {
        iso: 'NZ',
        phone: '64',
        address: [
            { localityname: { label: 'Town/city' } },
            {
                administrativearea: {
                    label: 'Region',
                    options: [
                        { AUK: 'Auckland' },
                        { BOP: 'Bay of Plenty' },
                        { CAN: 'Canterbury' },
                        { HKB: "Hawke's Bay" },
                        { MWT: 'Manawatu-Wanganui' },
                        { NTL: 'Northland' },
                        { OTA: 'Otago' },
                        { STL: 'Southland' },
                        { TKI: 'Taranaki' },
                        { WKO: 'Waikato' },
                        { WGN: 'Wellington' },
                        { WTC: 'West Coast' },
                        { GIS: 'Gisborne District' },
                        { MBH: 'Marlborough District' },
                        { NSN: 'Nelson' },
                        { TAS: 'Tasman District' },
                        { CIT: 'Chatham Islands Territory' },
                    ],
                },
            },
            { postalcode: { label: 'Postcode' } },
        ],
        name: 'New Zealand',
    },
    {
        iso: 'NI',
        phone: '505',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Department',
                    options: [
                        { AA: 'Boaco' },
                        { AA: 'Carazo' },
                        { AA: 'Chinandega' },
                        { AA: 'Chontales' },
                        { AA: 'Estelí' },
                        { AA: 'Granada' },
                        { AA: 'Jinotega' },
                        { AA: 'León Department' },
                        { AA: 'Madriz' },
                        { AA: 'Managua' },
                        { AA: 'Masaya' },
                        { AA: 'Matagalpa' },
                        { AA: 'Nueva Segovia' },
                        { AA: 'Rivas' },
                        { AA: 'Río San Juan' },
                        { AA: 'North Caribbean Coast Autonomous Region' },
                        { AA: 'South Caribbean Coast Autonomous Region' },
                    ],
                },
            },
        ],
        name: 'Nicaragua',
    },
    {
        iso: 'NE',
        phone: '227',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Niger',
    },
    {
        iso: 'NG',
        phone: '234',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AA: 'Abia' },
                        { AA: 'Adamawa' },
                        { AA: 'Akwa Ibom' },
                        { AA: 'Anambra' },
                        { AA: 'Bauchi' },
                        { AA: 'Bayelsa' },
                        { AA: 'Benue' },
                        { AA: 'Borno' },
                        { AA: 'Cross River' },
                        { AA: 'Delta' },
                        { AA: 'Ebonyi' },
                        { AA: 'Edo' },
                        { AA: 'Ekiti' },
                        { AA: 'Enugu' },
                        { AA: 'Federal Capital Territory' },
                        { AA: 'Gombe' },
                        { AA: 'Imo' },
                        { AA: 'Jigawa' },
                        { AA: 'Kaduna' },
                        { AA: 'Kano' },
                        { AA: 'Katsina' },
                        { AA: 'Kebbi' },
                        { AA: 'Kogi' },
                        { AA: 'Kwara' },
                        { AA: 'Lagos' },
                        { AA: 'Nasarawa' },
                        { AA: 'Niger' },
                        { AA: 'Ogun' },
                        { AA: 'Ondo' },
                        { AA: 'Osun' },
                        { AA: 'Oyo' },
                        { AA: 'Plateau' },
                        { AA: 'Rivers' },
                        { AA: 'Sokoto' },
                        { AA: 'Taraba' },
                        { AA: 'Yobe' },
                        { AA: 'Zamfara' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Nigeria',
    },
    {
        iso: 'NU',
        phone: '683',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Niue',
    },
    {
        iso: 'NF',
        phone: '672',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Norfolk Island',
    },
    {
        iso: 'KP',
        phone: '850',
        address: [{ localityname: { label: 'City' } }],
        name: 'North Korea',
    },
    {
        iso: 'MP',
        phone: '1670',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'ZIP Code' } }],
        name: 'Northern Mariana Islands',
    },
    {
        iso: 'NO',
        phone: '47',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '0025' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Norway',
    },
    {
        iso: 'OM',
        phone: '968',
        address: [
            { localityname: { label: 'City' } },
            { postalcode: { label: 'Postal Code' } },
            {
                administrativearea: {
                    label: 'Governorate',
                    options: [
                        { AA: 'Ad Dakhiliyah' },
                        { AA: 'Ad Dhahirah' },
                        { AA: 'Al Batinah North' },
                        { AA: 'Al Batinah South' },
                        { AA: 'Al Buraimi' },
                        { AA: 'Al Wusta' },
                        { AA: 'Ash Sharqiyah North' },
                        { AA: 'Ash Sharqiyah South' },
                        { AA: 'Dhofar' },
                        { AA: 'Muscat' },
                        { AA: 'Musandam' },
                    ],
                },
            },
        ],
        name: 'Oman',
    },
    {
        iso: 'PK',
        phone: '92',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Pakistan',
    },
    {
        iso: 'PW',
        phone: '680',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AA: 'Aimeliik' },
                        { AA: 'Airai' },
                        { AA: 'Angaur' },
                        { AA: 'Hatohobei' },
                        { AA: 'Kayangel' },
                        { AA: 'Koror' },
                        { AA: 'Melekeok' },
                        { AA: 'Ngaraard' },
                        { AA: 'Ngarchelong' },
                        { AA: 'Ngardmau' },
                        { AA: 'Ngatpang' },
                        { AA: 'Ngchesar' },
                        { AA: 'Ngeremlengui' },
                        { AA: 'Ngiwal' },
                        { AA: 'Peleliu' },
                        { AA: 'Sonsorol' },
                    ],
                },
            },
            { postalcode: { label: 'ZIP Code' } },
        ],
        name: 'Palau',
    },
    {
        iso: 'PS',
        phone: '970',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Palestinian Territory',
    },
    {
        iso: 'PA',
        phone: '507',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Bocas del Toro' },
                        { AA: 'Chiriquí' },
                        { AA: 'Coclé' },
                        { AA: 'Colón' },
                        { AA: 'Darién' },
                        { AA: 'Herrera' },
                        { AA: 'Los Santos' },
                        { AA: 'Panamá' },
                        { AA: 'Panamá Oeste' },
                        { AA: 'Veraguas' },
                    ],
                },
            },
        ],
        name: 'Panama',
    },
    {
        iso: 'PG',
        phone: '675',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Autonomous Region of Bougainville' },
                        { AA: 'Central' },
                        { AA: 'Eastern Highlands' },
                        { AA: 'East New Britain' },
                        { AA: 'East Sepik' },
                        { AA: 'Enga' },
                        { AA: 'Gulf' },
                        { AA: 'Hela' },
                        { AA: 'Jiwaka' },
                        { AA: 'Madang' },
                        { AA: 'Manus' },
                        { AA: 'Milne Bay' },
                        { AA: 'Morobe' },
                        { AA: 'National Capital District' },
                        { AA: 'New Ireland' },
                        { AA: 'Oro (Northern)' },
                        { AA: 'Sandaun (West Sepik)' },
                        { AA: 'Simbu (Chimbu)' },
                        { AA: 'Southern Highlands' },
                        { AA: 'Western (Fly)' },
                        { AA: 'Western Highlands' },
                        { AA: 'West New Britain' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Papua New Guinea',
    },
    {
        iso: 'PY',
        phone: '595',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Paraguay',
    },
    {
        iso: 'PE',
        phone: '51',
        address: [
            { postalcode: { label: 'Postal Code' } },
            {
                administrativearea: {
                    label: 'Region',
                    options: [
                        { AMA: 'Amazonas' },
                        { ANC: 'Ancash' },
                        { APU: 'Apurimac' },
                        { ARE: 'Arequipa' },
                        { AYA: 'Ayacucho' },
                        { CAJ: 'Cajamarca' },
                        { CAL: 'Callao' },
                        { CUS: 'Cusco' },
                        { HUV: 'Huancavelica' },
                        { HUC: 'Huanuco' },
                        { ICA: 'Ica' },
                        { JUN: 'Junin' },
                        { LAL: 'La Libertad' },
                        { LAM: 'Lambayeque' },
                        { LIM: 'Lima' },
                        { LOR: 'Loreto' },
                        { MDD: 'Madre de Dios' },
                        { MOQ: 'Moquegua' },
                        { PAS: 'Pasco' },
                        { PIU: 'Piura' },
                        { PUN: 'Puno' },
                        { SAM: 'San Martin' },
                        { TAC: 'Tacna' },
                        { TUM: 'Tumbes' },
                        { UCA: 'Ucayali' },
                    ],
                },
            },
            { localityname: { label: 'District' } },
        ],
        name: 'Peru',
    },
    {
        iso: 'PH',
        phone: '63',
        address: [
            { dependent_localityname: { label: 'Suburb' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Abra' },
                        { AA: 'Agusan del Norte' },
                        { AA: 'Agusan del Sur' },
                        { AA: 'Aklan' },
                        { AA: 'Albay' },
                        { AA: 'Antique' },
                        { AA: 'Apayao' },
                        { AA: 'Aurora' },
                        { AA: 'Basilan' },
                        { AA: 'Bataan' },
                        { AA: 'Batanes' },
                        { AA: 'Batangas' },
                        { AA: 'Benguet' },
                        { AA: 'Biliran' },
                        { AA: 'Bohol' },
                        { AA: 'Bukidnon' },
                        { AA: 'Bulacan' },
                        { AA: 'Cagayan' },
                        { AA: 'Camarines Norte' },
                        { AA: 'Camarines Sur' },
                        { AA: 'Camiguin' },
                        { AA: 'Capiz' },
                        { AA: 'Catanduanes' },
                        { AA: 'Cavite' },
                        { AA: 'Cebu' },
                        { AA: 'Compostela Valley' },
                        { AA: 'Cotabato' },
                        { AA: 'Davao del Norte' },
                        { AA: 'Davao del Sur' },
                        { AA: 'Davao Occidental' },
                        { AA: 'Davao Oriental' },
                        { AA: 'Dinagat Islands' },
                        { AA: 'Eastern Samar' },
                        { AA: 'Guimaras' },
                        { AA: 'Ifugao' },
                        { AA: 'Ilocos Norte' },
                        { AA: 'Ilocos Sur' },
                        { AA: 'Iloilo' },
                        { AA: 'Isabela' },
                        { AA: 'Kalinga' },
                        { AA: 'La Union' },
                        { AA: 'Laguna' },
                        { AA: 'Lanao del Norte' },
                        { AA: 'Lanao del Sur' },
                        { AA: 'Leyte' },
                        { AA: 'Maguindanao' },
                        { AA: 'Marinduque' },
                        { AA: 'Masbate' },
                        { AA: 'Metro Manila' },
                        { AA: 'Misamis Occidental' },
                        { AA: 'Misamis Oriental' },
                        { AA: 'Mountain Province' },
                        { AA: 'Negros Occidental' },
                        { AA: 'Negros Oriental' },
                        { AA: 'Northern Samar' },
                        { AA: 'Nueva Ecija' },
                        { AA: 'Nueva Vizcaya' },
                        { AA: 'Occidental Mindoro' },
                        { AA: 'Oriental Mindoro' },
                        { AA: 'Palawan' },
                        { AA: 'Pampanga' },
                        { AA: 'Pangasinan' },
                        { AA: 'Quezon' },
                        { AA: 'Quirino' },
                        { AA: 'Rizal' },
                        { AA: 'Romblon' },
                        { AA: 'Samar' },
                        { AA: 'Sarangani' },
                        { AA: 'Sibugay Ipil' },
                        { AA: 'Siquijor' },
                        { AA: 'Sorsogon' },
                        { AA: 'South Cotabato' },
                        { AA: 'Southern Leyte' },
                        { AA: 'Sultan Kudarat' },
                        { AA: 'Sulu' },
                        { AA: 'Surigao del Norte' },
                        { AA: 'Surigao del Sur' },
                        { AA: 'Tarlac' },
                        { AA: 'Tawi-Tawi' },
                        { AA: 'Zambales' },
                        { AA: 'Zamboanga del Norte' },
                        { AA: 'Zamboanga del Sur' },
                        { AA: 'Zamboanga' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Philippines',
    },
    {
        iso: 'PN',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Pitcairn',
    },
    {
        iso: 'PL',
        phone: '48',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{2}-?\\d{3}$',
                    eg: '00-950',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Poland',
    },
    {
        iso: 'PT',
        phone: '351',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{4}-?\\d{3}$',
                    eg: '2725-079',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Portugal',
    },
    {
        iso: 'PR',
        phone: '1',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'ZIP Code' } }],
        name: 'Puerto Rico',
    },
    {
        iso: 'QA',
        phone: '974',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Qatar',
    },
    {
        iso: 'RO',
        phone: '40',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Romania',
    },
    {
        iso: 'RU',
        phone: '7',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { MOW: 'Moskva' },
                        { SPE: 'Sankt-Peterburg' },
                        { AD: 'Adygeya, Respublika' },
                        { AL: 'Altay, Respublika' },
                        { BA: 'Bashkortostan, Respublika' },
                        { BU: 'Buryatiya, Respublika' },
                        { CE: 'Chechenskaya Respublika' },
                        { CU: 'Chuvashskaya Respublika' },
                        { DA: 'Dagestan, Respublika' },
                        { IN: 'Ingushetiya, Respublika' },
                        { KB: 'Kabardino-Balkarskaya Respublika' },
                        { KL: 'Kalmykiya, Respublika' },
                        { KC: 'Karachayevo-Cherkesskaya Respublika' },
                        { KR: 'Kareliya, Respublika' },
                        { KK: 'Khakasiya, Respublika' },
                        { KO: 'Komi, Respublika' },
                        { ME: 'Mariy El, Respublika' },
                        { MO: 'Mordoviya, Respublika' },
                        { SA: 'Sakha, Respublika [Yakutiya]' },
                        { SE: 'Severnaya Osetiya-Alaniya, Respublika' },
                        { TA: 'Tatarstan, Respublika' },
                        { TY: 'Tyva, Respublika [Tuva]' },
                        { UD: 'Udmurtskaya Respublika' },
                        { ALT: 'Altayskiy kray' },
                        { KAM: 'Kamchatskiy kray' },
                        { KHA: 'Khabarovskiy kray' },
                        { KDA: 'Krasnodarskiy kray' },
                        { KYA: 'Krasnoyarskiy kray' },
                        { PER: 'Permskiy kray' },
                        { PRI: 'Primorskiy kray' },
                        { STA: 'Stavropolskiy kray' },
                        { ZAB: 'Zabaykalskiy kray' },
                        { AMU: 'Amurskaya oblast' },
                        { ARK: 'Arkhangelskaya oblast' },
                        { AST: 'Astrakhanskaya oblast' },
                        { BEL: 'Belgorodskaya oblast' },
                        { BRY: 'Bryanskaya oblast' },
                        { CHE: 'Chelyabinskaya oblast' },
                        { IRK: 'Irkutskaya oblast' },
                        { IVA: 'Ivanovskaya oblast' },
                        { KGD: 'Kaliningradskaya oblast' },
                        { KLU: 'Kaluzhskaya oblast' },
                        { KEM: 'Kemerovskaya oblast' },
                        { KIR: 'Kirovskaya oblast' },
                        { KOS: 'Kostromskaya oblast' },
                        { KGN: 'Kurganskaya oblast' },
                        { KRS: 'Kurskaya oblast' },
                        { LEN: 'Leningradskaya oblast' },
                        { LIP: 'Lipetskaya oblast' },
                        { MAG: 'Magadanskaya oblast' },
                        { MOS: 'Moskovskaya oblast' },
                        { MUR: 'Murmanskaya oblast' },
                        { NIZ: 'Nizhegorodskaya oblast' },
                        { NGR: 'Novgorodskaya oblast' },
                        { NVS: 'Novosibirskaya oblast' },
                        { OMS: 'Omskaya oblast' },
                        { ORE: 'Orenburgskaya oblast' },
                        { ORL: 'Orlovskaya oblast' },
                        { PNZ: 'Penzenskaya oblast' },
                        { PSK: 'Pskovskaya oblast' },
                        { ROS: 'Rostovskaya oblast' },
                        { RYA: 'Ryazanskaya oblast' },
                        { SAK: 'Sakhalinskaya oblast' },
                        { SAM: 'Samarskaya oblast' },
                        { SAR: 'Saratovskaya oblast' },
                        { SMO: 'Smolenskaya oblast' },
                        { SVE: 'Sverdlovskaya oblast' },
                        { TAM: 'Tambovskaya oblast' },
                        { TOM: 'Tomskaya oblast' },
                        { TUL: 'Tulskaya oblast' },
                        { TVE: 'Tverskaya oblast' },
                        { TYU: 'Tyumenskaya oblast' },
                        { ULY: 'Ulyanovskaya oblast' },
                        { VLA: 'Vladimirskaya oblast' },
                        { VGG: 'Volgogradskaya oblast' },
                        { VLG: 'Vologodskaya oblast' },
                        { VOR: 'Voronezhskaya oblast' },
                        { YAR: 'Yaroslavskaya oblast' },
                        { YEV: 'Yevreyskaya avtonomnaya oblast' },
                        { CHU: 'Chukotskiy avtonomnyy okrug' },
                        { KHM: 'Khanty-Mansiyskiy avtonomnyy okrug-Yugra' },
                        { NEN: 'Nenetskiy avtonomnyy okrug' },
                        { YAN: 'Yamalo-Nenetskiy avtonomnyy okrug' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Russia',
    },
    {
        iso: 'RW',
        phone: '250',
        address: [{ localityname: { label: 'City' } }],
        name: 'Rwanda',
    },
    {
        iso: 'RE',
        phone: '262',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78]4\\d{2}$',
                    eg: '97400',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Réunion',
    },
    {
        iso: 'BL',
        phone: '590',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78][01]\\d{2}$',
                    eg: '97100',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Saint Barthélemy',
    },
    {
        iso: 'SH',
        phone: '290',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^(ASCN|STHL)[ ]?1ZZ$',
                    eg: 'STHL 1ZZ',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Saint Helena',
    },
    {
        iso: 'KN',
        phone: '1869',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [{ AA: 'Nevis' }, { AA: 'Saint Kitts' }],
                },
            },
        ],
        name: 'Saint Kitts and Nevis',
    },
    {
        iso: 'LC',
        phone: '1758',
        address: [{ localityname: { label: 'City' } }],
        name: 'Saint Lucia',
    },
    {
        iso: 'MF',
        phone: '590',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78][01]\\d{2}$',
                    eg: '97100',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Saint Martin',
    },
    {
        iso: 'PM',
        phone: '508',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^9[78]5\\d{2}$',
                    eg: '97500',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Saint Pierre and Miquelon',
    },
    {
        iso: 'VC',
        phone: '1784',
        address: [{ localityname: { label: 'City' } }],
        name: 'Saint Vincent and the Grenadines',
    },
    {
        iso: 'WS',
        phone: '685',
        address: [{ localityname: { label: 'City' } }],
        name: 'Samoa',
    },
    {
        iso: 'SM',
        phone: '378',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'San Marino',
    },
    {
        iso: 'SA',
        phone: '966',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Saudi Arabia',
    },
    {
        iso: 'SN',
        phone: '221',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Senegal',
    },
    {
        iso: 'RS',
        phone: '381',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Serbia',
    },
    {
        iso: 'SC',
        phone: '248',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [
                        { AA: 'Anse Boileau' },
                        { AA: 'Anse Etoile' },
                        { AA: 'Anse Royale' },
                        { AA: 'Anse aux Pins' },
                        { AA: 'Au Cap' },
                        { AA: 'Baie Lazare' },
                        { AA: 'Baie Sainte Anne' },
                        { AA: 'Beau Vallon' },
                        { AA: 'Bel Air' },
                        { AA: 'Bel Ombre' },
                        { AA: 'Cascade' },
                        { AA: 'Glacis' },
                        { AA: "Grand'Anse Mahé" },
                        { AA: "Grand'Anse Praslin" },
                        { AA: 'La Digue' },
                        { AA: 'La Rivière Anglaise' },
                        { AA: 'Les Mamelles' },
                        { AA: 'Mont Buxton' },
                        { AA: 'Mont Fleuri' },
                        { AA: 'Plaisance' },
                        { AA: 'Pointe La Rue' },
                        { AA: 'Port Glaud' },
                        { AA: 'Roche Caiman' },
                        { AA: 'Saint Louis' },
                        { AA: 'Takamaka' },
                    ],
                },
            },
        ],
        name: 'Seychelles',
    },
    {
        iso: 'SL',
        phone: '232',
        address: [{ localityname: { label: 'City' } }],
        name: 'Sierra Leone',
    },
    {
        iso: 'SG',
        phone: '65',
        address: [
            { localityname: { label: 'City' } },
            {
                postalcode: { label: 'Postal Code', format: '^\\d{6}$', eg: '238880' },
            },
        ],
        name: 'Singapore',
    },
    { iso: 'SX', phone: '1721', address: [], name: 'Sint Maarten' },
    {
        iso: 'SK',
        phone: '421',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Slovakia',
    },
    {
        iso: 'SI',
        phone: '386',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Slovenia',
    },
    {
        iso: 'SB',
        phone: '677',
        address: [{ localityname: { label: 'City' } }],
        name: 'Solomon Islands',
    },
    {
        iso: 'SO',
        phone: '252',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { AA: 'Galmudug' },
                        { AA: 'Hirshabelle' },
                        { AA: 'Jubaland' },
                        { AA: 'Puntland' },
                        { AA: 'Somaliland' },
                        { AA: 'South West State' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Somalia',
    },
    {
        iso: 'ZA',
        phone: '27',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { 'Eastern Cape': 'Eastern Cape' },
                        { 'Free State': 'Free State' },
                        { Gauteng: 'Gauteng' },
                        { 'KwaZulu-Natal': 'KwaZulu-Natal' },
                        { Limpopo: 'Limpopo' },
                        { Mpumalanga: 'Mpumalanga' },
                        { 'North West': 'North West' },
                        { 'Northern Cape': 'Northern Cape' },
                        { 'Western Cape': 'Western Cape' },
                    ],
                },
            },
        ],
        name: 'South Africa',
    },
    {
        iso: 'GS',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'South Georgia and the South Sandwich Islands',
    },
    {
        iso: 'KR',
        phone: '82',
        address: [
            { dependent_localityname: { label: 'District' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { Seoul: 'Seoul' },
                        { Busan: 'Busan' },
                        { Daegu: 'Daegu' },
                        { Daejeon: 'Daejeon' },
                        { Gwangju: 'Gwangju' },
                        { Incheon: 'Incheon' },
                        { Ulsan: 'Ulsan' },
                        { 'Chungcheongbuk-do': 'Chungcheongbuk-do' },
                        { 'Chungcheongnam-do': 'Chungcheongnam-do' },
                        { 'Gangwon-do': 'Gangwon-do' },
                        { 'Gyeonggi-do': 'Gyeonggi-do' },
                        { 'Gyeongsangbuk-do': 'Gyeongsangbuk-do' },
                        { 'Gyeongsangnam-do': 'Gyeongsangnam-do' },
                        { 'Jeju-do': 'Jeju-do' },
                        { 'Jeollabuk-do': 'Jeollabuk-do' },
                        { 'Jeollanam-do': 'Jeollanam-do' },
                        { Sejong: 'Sejong' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'South Korea',
    },
    { iso: 'SS', phone: '211', address: [], name: 'South Sudan' },
    {
        iso: 'ES',
        phone: '34',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { C: 'A Coruña' },
                        { VI: 'Alava' },
                        { AB: 'Albacete' },
                        { A: 'Alicante' },
                        { AL: 'Almería' },
                        { O: 'Asturias' },
                        { AV: 'Ávila' },
                        { BA: 'Badajoz' },
                        { PM: 'Baleares' },
                        { B: 'Barcelona' },
                        { BU: 'Burgos' },
                        { CC: 'Cáceres' },
                        { CA: 'Cádiz' },
                        { S: 'Cantabria' },
                        { CS: 'Castellón' },
                        { CE: 'Ceuta' },
                        { CR: 'Ciudad Real' },
                        { CO: 'Córdoba' },
                        { CU: 'Cuenca' },
                        { GI: 'Gerona' },
                        { GR: 'Granada' },
                        { GU: 'Guadalajara' },
                        { SS: 'Guipúzcoa' },
                        { H: 'Huelva' },
                        { HU: 'Huesca' },
                        { J: 'Jaén' },
                        { LO: 'La Rioja' },
                        { GC: 'Las Palmas' },
                        { LE: 'León' },
                        { L: 'Lérida' },
                        { LU: 'Lugo' },
                        { M: 'Madrid' },
                        { MA: 'Málaga' },
                        { ML: 'Melilla' },
                        { MU: 'Murcia' },
                        { NA: 'Navarra' },
                        { OR: 'Ourense' },
                        { P: 'Palencia' },
                        { PO: 'Pontevedra' },
                        { SA: 'Salamanca' },
                        { TF: 'Santa Cruz de Tenerife' },
                        { SG: 'Segovia' },
                        { SE: 'Sevilla' },
                        { SO: 'Soria' },
                        { T: 'Tarragona' },
                        { TE: 'Teruel' },
                        { TO: 'Toledo' },
                        { V: 'Valencia' },
                        { VA: 'Valladolid' },
                        { BI: 'Vizcaya' },
                        { ZA: 'Zamora' },
                        { Z: 'Zaragoza' },
                    ],
                },
            },
        ],
        name: 'Spain',
    },
    {
        iso: 'LK',
        phone: '94',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Sri Lanka',
    },
    {
        iso: 'SD',
        phone: '249',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Sudan',
    },
    {
        iso: 'SR',
        phone: '597',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'District',
                    options: [
                        { AA: 'Brokopondo' },
                        { AA: 'Commewijne' },
                        { AA: 'Coronie' },
                        { AA: 'Marowijne' },
                        { AA: 'Nickerie' },
                        { AA: 'Para' },
                        { AA: 'Paramaribo' },
                        { AA: 'Saramacca' },
                        { AA: 'Sipaliwini' },
                        { AA: 'Wanica' },
                    ],
                },
            },
        ],
        name: 'Suriname',
    },
    {
        iso: 'SJ',
        phone: '47',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '9170' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Svalbard and Jan Mayen',
    },
    {
        iso: 'SZ',
        phone: '268',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Swaziland',
    },
    {
        iso: 'SE',
        phone: '46',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{3}[ ]?\\d{2}$',
                    eg: '11455',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Sweden',
    },
    {
        iso: 'CH',
        phone: '41',
        address: [
            { postalcode: { label: 'Postal Code', format: '^\\d{4}$', eg: '2544' } },
            { localityname: { label: 'City' } },
        ],
        name: 'Switzerland',
    },
    {
        iso: 'SY',
        phone: '963',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Syria',
    },
    {
        iso: 'ST',
        phone: '239',
        address: [{ localityname: { label: 'City' } }],
        name: 'São Tomé and Príncipe',
    },
    {
        iso: 'TW',
        phone: '886',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^\\d{3}(\\d{2})?$',
                    eg: '100',
                },
            },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { TXG: 'Taichung City' },
                        { TPE: 'Taipei City' },
                        { TTT: 'Taitung County' },
                        { TNN: 'Tainan City' },
                        { ILA: 'Yilan County' },
                        { HUA: 'Hualien County' },
                        { 'Kinmen County': 'Kinmen County' },
                        { NAN: 'Nantou County' },
                        { PIF: 'Pingtung County' },
                        { MIA: 'Miaoli County' },
                        { TAO: 'Taoyuan County' },
                        { KHH: 'Kaohsiung City' },
                        { KEE: 'Keelung City' },
                        { 'Lienchiang County': 'Lienchiang County' },
                        { YUN: 'Yunlin County' },
                        { TPQ: 'New Taipei City' },
                        { HSZ: 'Hsinchu City' },
                        { HSQ: 'Hsinchu County' },
                        { CYI: 'Chiayi City' },
                        { CYQ: 'Chiayi County' },
                        { CHA: 'Changhua County' },
                        { PEN: 'Penghu County' },
                    ],
                },
            },
        ],
        name: 'Taiwan',
    },
    {
        iso: 'TJ',
        phone: '992',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Tajikistan',
    },
    {
        iso: 'TZ',
        phone: '255',
        address: [{ localityname: { label: 'City' } }],
        name: 'Tanzania',
    },
    {
        iso: 'TH',
        phone: '66',
        address: [
            { dependent_localityname: { label: 'Suburb' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Amnat Charoen' },
                        { AA: 'Angthong' },
                        { AA: 'Ayutthaya' },
                        { AA: 'Bangkok' },
                        { AA: 'Buriram' },
                        { AA: 'Chachoengsao' },
                        { AA: 'Chainat' },
                        { AA: 'Chaiyaphum' },
                        { AA: 'Chanthaburi' },
                        { AA: 'Chiang Mai' },
                        { AA: 'Chiang Rai' },
                        { AA: 'Chonburi' },
                        { AA: 'Chumphon' },
                        { AA: 'Kalasin' },
                        { AA: 'Kamphaeng Phet' },
                        { AA: 'Kanchanaburi' },
                        { AA: 'Khon Kaen' },
                        { AA: 'Krabi' },
                        { AA: 'Lampang' },
                        { AA: 'Lamphun' },
                        { AA: 'Loei' },
                        { AA: 'Lopburi' },
                        { AA: 'Mae Hong Son' },
                        { AA: 'Mahasarakham' },
                        { AA: 'Mukdahan' },
                        { AA: 'Nakhon Phanom' },
                        { AA: 'Nakhon Ratchasima' },
                        { AA: 'Nakhon Sawan' },
                        { AA: 'Nakhon Srithammarat' },
                        { AA: 'Nakhonnayok' },
                        { AA: 'Nakhonpathom' },
                        { AA: 'Nan' },
                        { AA: 'Narathiwat' },
                        { AA: 'Nong Bualumphu' },
                        { AA: 'Nong Khai' },
                        { AA: 'Nonthaburi' },
                        { AA: 'Pathumthani' },
                        { AA: 'Pattani' },
                        { AA: 'Phangnga' },
                        { AA: 'Phattalung' },
                        { AA: 'Phayao' },
                        { AA: 'Phetchabun' },
                        { AA: 'Phetchaburi' },
                        { AA: 'Phichit' },
                        { AA: 'Phitsanulok' },
                        { AA: 'Phrae' },
                        { AA: 'Phuket' },
                        { AA: 'Prachinburi' },
                        { AA: 'Prachuap Khirikhan' },
                        { AA: 'Ranong' },
                        { AA: 'Ratchaburi' },
                        { AA: 'Rayong' },
                        { AA: 'Roi Et' },
                        { AA: 'Sakaeo' },
                        { AA: 'Sakon Nakhon' },
                        { AA: 'Samutprakan' },
                        { AA: 'Samutsakhon' },
                        { AA: 'Samutsongkhram' },
                        { AA: 'Saraburi' },
                        { AA: 'Satun' },
                        { AA: 'Si Sa Ket' },
                        { AA: 'Singburi' },
                        { AA: 'Songkla' },
                        { AA: 'Sukhothai' },
                        { AA: 'Suphanburi' },
                        { AA: 'Surat Thani' },
                        { AA: 'Surin' },
                        { AA: 'Tak' },
                        { AA: 'Trang' },
                        { AA: 'Trat' },
                        { AA: 'Ubon Ratchathani' },
                        { AA: 'Udon Thani' },
                        { AA: 'Uthai Thani' },
                        { AA: 'Uttaradit' },
                        { AA: 'Yala' },
                        { AA: 'Yasothon' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Thailand',
    },
    {
        iso: 'TL',
        phone: '670',
        address: [{ localityname: { label: 'City' } }],
        name: 'Timor-Leste',
    },
    {
        iso: 'TG',
        phone: '228',
        address: [{ localityname: { label: 'City' } }],
        name: 'Togo',
    },
    {
        iso: 'TK',
        phone: '690',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Tokelau',
    },
    {
        iso: 'TO',
        phone: '676',
        address: [{ localityname: { label: 'City' } }],
        name: 'Tonga',
    },
    {
        iso: 'TT',
        phone: '1868',
        address: [{ localityname: { label: 'City' } }],
        name: 'Trinidad and Tobago',
    },
    {
        iso: 'TN',
        phone: '216',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Tunisia',
    },
    {
        iso: 'TR',
        phone: '90',
        address: [
            { postalcode: { label: 'Postal Code' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { Adana: 'Adana' },
                        { Adıyaman: 'Adıyaman' },
                        { Afyon: 'Afyon' },
                        { Ağrı: 'Ağrı' },
                        { Aksaray: 'Aksaray' },
                        { Amasya: 'Amasya' },
                        { Ankara: 'Ankara' },
                        { Antalya: 'Antalya' },
                        { Ardahan: 'Ardahan' },
                        { Artvin: 'Artvin' },
                        { Aydın: 'Aydın' },
                        { Balıkesir: 'Balıkesir' },
                        { Bartın: 'Bartın' },
                        { Batman: 'Batman' },
                        { Bayburt: 'Bayburt' },
                        { Bilecik: 'Bilecik' },
                        { Bingöl: 'Bingöl' },
                        { Bitlis: 'Bitlis' },
                        { Bolu: 'Bolu' },
                        { Burdur: 'Burdur' },
                        { Bursa: 'Bursa' },
                        { Çanakkale: 'Çanakkale' },
                        { Çankırı: 'Çankırı' },
                        { Çorum: 'Çorum' },
                        { Denizli: 'Denizli' },
                        { Diyarbakır: 'Diyarbakır' },
                        { Düzce: 'Düzce' },
                        { Edirne: 'Edirne' },
                        { Elazığ: 'Elazığ' },
                        { Erzincan: 'Erzincan' },
                        { Erzurum: 'Erzurum' },
                        { Eskişehir: 'Eskişehir' },
                        { Gaziantep: 'Gaziantep' },
                        { Giresun: 'Giresun' },
                        { Gümüşhane: 'Gümüşhane' },
                        { Hakkari: 'Hakkari' },
                        { Hatay: 'Hatay' },
                        { Iğdır: 'Iğdır' },
                        { Isparta: 'Isparta' },
                        { İstanbul: 'İstanbul' },
                        { İzmir: 'İzmir' },
                        { Kahramanmaraş: 'Kahramanmaraş' },
                        { Karabük: 'Karabük' },
                        { Karaman: 'Karaman' },
                        { Kars: 'Kars' },
                        { Kastamonu: 'Kastamonu' },
                        { Kayseri: 'Kayseri' },
                        { Kırıkkale: 'Kırıkkale' },
                        { Kırklareli: 'Kırklareli' },
                        { Kırşehir: 'Kırşehir' },
                        { Kilis: 'Kilis' },
                        { Kocaeli: 'Kocaeli' },
                        { Konya: 'Konya' },
                        { Kütahya: 'Kütahya' },
                        { Malatya: 'Malatya' },
                        { Manisa: 'Manisa' },
                        { Mardin: 'Mardin' },
                        { Mersin: 'Mersin' },
                        { Muğla: 'Muğla' },
                        { Muş: 'Muş' },
                        { Nevşehir: 'Nevşehir' },
                        { Niğde: 'Niğde' },
                        { Ordu: 'Ordu' },
                        { Osmaniye: 'Osmaniye' },
                        { Rize: 'Rize' },
                        { Sakarya: 'Sakarya' },
                        { Samsun: 'Samsun' },
                        { Siirt: 'Siirt' },
                        { Sinop: 'Sinop' },
                        { Sivas: 'Sivas' },
                        { Şanlıurfa: 'Şanlıurfa' },
                        { Şırnak: 'Şırnak' },
                        { Tekirdağ: 'Tekirdağ' },
                        { Tokat: 'Tokat' },
                        { Trabzon: 'Trabzon' },
                        { Tunceli: 'Tunceli' },
                        { Uşak: 'Uşak' },
                        { Van: 'Van' },
                        { Yalova: 'Yalova' },
                        { Yozgat: 'Yozgat' },
                        { Zonguldak: 'Zonguldak' },
                    ],
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Turkey',
    },
    {
        iso: 'TM',
        phone: '993',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Turkmenistan',
    },
    {
        iso: 'TC',
        phone: '1649',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Turks and Caicos Islands',
    },
    {
        iso: 'TV',
        phone: '688',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Island',
                    options: [
                        { Funafuti: 'Funafuti' },
                        { 'Funafuti Centre': 'Funafuti Centre' },
                        { Nanumaga: 'Nanumaga' },
                        { Nanumea: 'Nanumea' },
                        { Niulakita: 'Niulakita' },
                        { Niutao: 'Niutao' },
                        { Nui: 'Nui' },
                        { Nukulaelae: 'Nukulaelae' },
                        { Vaitupu: 'Vaitupu' },
                    ],
                },
            },
        ],
        name: 'Tuvalu',
    },
    {
        iso: 'VI',
        phone: '1340',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'U.S. Virgin Islands',
    },
    {
        iso: 'UG',
        phone: '256',
        address: [{ localityname: { label: 'City' } }],
        name: 'Uganda',
    },
    {
        iso: 'UA',
        phone: '380',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Region',
                    options: [
                        { AA: 'Cherkasy' },
                        { AA: 'Chernihiv' },
                        { AA: 'Chernivtsi' },
                        { AA: 'Dnipropetrovsk' },
                        { AA: 'Donetsk' },
                        { AA: 'Ivano-Frankivsk' },
                        { AA: 'Kharkiv' },
                        { AA: 'Kherson' },
                        { AA: 'Khmelnytskyi' },
                        { AA: 'Kiev' },
                        { AA: 'Kirovohrad' },
                        { AA: 'Luhansk' },
                        { AA: 'Lviv' },
                        { AA: 'Mykolaiv' },
                        { AA: 'Odessa' },
                        { AA: 'Poltava' },
                        { AA: 'Rivne' },
                        { AA: 'Sumy' },
                        { AA: 'Ternopil' },
                        { AA: 'Vinnytsia' },
                        { AA: 'Volyn' },
                        { AA: 'Zakarpattia' },
                        { AA: 'Zaporizhia' },
                        { AA: 'Zhytomyr' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Ukraine',
    },
    {
        iso: 'AE',
        phone: '971',
        address: [
            {
                administrativearea: {
                    label: 'Emirate',
                    options: [
                        { AZ: 'Abu Dhabi' },
                        { FU: 'Fujairah' },
                        { UQ: 'Umm al-Quwain' },
                        { SH: 'Sharjah' },
                        { DU: 'Dubai' },
                        { RK: 'Ras al-Khaimah' },
                        { AJ: 'Ajmān' },
                    ],
                },
            },
        ],
        name: 'United Arab Emirates',
    },
    {
        iso: 'GB',
        phone: '44',
        address: [
            { localityname: { label: 'Town/city' } },
            {
                administrativearea: {
                    label: 'County',
                    options: [
                        { AA: 'Aberdeenshire' },
                        { AA: 'Angus (Forfarshire)' },
                        { AA: 'Antrim' },
                        { AA: 'Argyll' },
                        { AA: 'Armagh' },
                        { AA: 'Ayrshire' },
                        { AA: 'Banffshire' },
                        { AA: 'Bedfordshire' },
                        { AA: 'Berkshire' },
                        { AA: 'Berwickshire' },
                        { AA: 'Blaenau Gwent' },
                        { AA: 'Bridgend' },
                        { AA: 'Buckinghamshire' },
                        { AA: 'Bute' },
                        { AA: 'Caerphilly' },
                        { AA: 'Caithness' },
                        { AA: 'Cambridgeshire' },
                        { AA: 'Cardiff' },
                        { AA: 'Carmarthenshire' },
                        { AA: 'Ceredigion' },
                        { AA: 'Cheshire' },
                        { AA: 'City of Aberdeen' },
                        { AA: 'City of Belfast' },
                        { AA: 'City of Bristol' },
                        { AA: 'City of Derry' },
                        { AA: 'City of Dundee' },
                        { AA: 'City of Edinburgh' },
                        { AA: 'City of Glasgow' },
                        { AA: 'City of London' },
                        { AA: 'Clackmannanshire' },
                        { AA: 'Conwy' },
                        { AA: 'Cornwall' },
                        { AA: 'Cumbria' },
                        { AA: 'Denbighshire' },
                        { AA: 'Derbyshire' },
                        { AA: 'Devon' },
                        { AA: 'Dorset' },
                        { AA: 'Down' },
                        { AA: 'Dumfriesshire' },
                        { AA: 'Dunbartonshire (Dumbarton)' },
                        { AA: 'Durham (County Durham)' },
                        { AA: 'East Lothian (Haddingtonshire)' },
                        { AA: 'East Sussex' },
                        { AA: 'Essex' },
                        { AA: 'Fermanagh' },
                        { AA: 'Fife' },
                        { AA: 'Flintshire' },
                        { AA: 'Gloucestershire' },
                        { AA: 'Greater London' },
                        { AA: 'Greater Manchester' },
                        { AA: 'Gwynedd' },
                        { AA: 'Hampshire' },
                        { AA: 'Herefordshire' },
                        { AA: 'Hertfordshire' },
                        { AA: 'Inverness-shire' },
                        { AA: 'Isle of Anglesey' },
                        { AA: 'Isle of Wight' },
                        { AA: 'Kent' },
                        { AA: 'Kincardineshire' },
                        { AA: 'Kinross-shire' },
                        { AA: 'Kirkcudbrightshire' },
                        { AA: 'Lanarkshire' },
                        { AA: 'Lancashire' },
                        { AA: 'Leicestershire' },
                        { AA: 'Lincolnshire' },
                        { AA: 'London' },
                        { AA: 'Londonderry' },
                        { AA: 'Merseyside' },
                        { AA: 'Merthyr Tydfil' },
                        { AA: 'Midlothian (County of Edinburgh)' },
                        { AA: 'Monmouthshire' },
                        { AA: 'Moray' },
                        { AA: 'Nairnshire' },
                        { AA: 'Neath Port Talbot' },
                        { AA: 'Newport' },
                        { AA: 'Norfolk' },
                        { AA: 'North Yorkshire' },
                        { AA: 'Northamptonshire' },
                        { AA: 'Northumberland' },
                        { AA: 'Nottinghamshire' },
                        { AA: 'Orkney' },
                        { AA: 'Oxfordshire' },
                        { AA: 'Peeblesshire' },
                        { AA: 'Pembrokeshire' },
                        { AA: 'Perthshire' },
                        { AA: 'Powys' },
                        { AA: 'Renfrewshire' },
                        { AA: 'Rhondda Cynon Taf' },
                        { AA: 'Ross and Cromarty' },
                        { AA: 'Roxburghshire' },
                        { AA: 'Rutland' },
                        { AA: 'Selkirkshire' },
                        { AA: 'Shetland (Zetland)' },
                        { AA: 'Shropshire' },
                        { AA: 'Somerset' },
                        { AA: 'South Yorkshire' },
                        { AA: 'Staffordshire' },
                        { AA: 'Stirlingshire' },
                        { AA: 'Suffolk' },
                        { AA: 'Surrey' },
                        { AA: 'Sutherland' },
                        { AA: 'Swansea' },
                        { AA: 'Torfaen' },
                        { AA: 'Tyne and Wear' },
                        { AA: 'Tyrone' },
                        { AA: 'Vale of Glamorgan' },
                        { AA: 'Warwickshire' },
                        { AA: 'West Lothian (Linlithgowshire)' },
                        { AA: 'West Midlands' },
                        { AA: 'West Sussex' },
                        { AA: 'West Yorkshire' },
                        { AA: 'Wigtownshire' },
                        { AA: 'Wiltshire' },
                        { AA: 'Worcestershire' },
                        { AA: 'Wrexham' },
                        { AA: 'Yorkshire, East Riding' },
                    ],
                },
            },
            {
                postalcode: {
                    label: 'Postcode',
                    format: '^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?[ ]?\\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\\d{1,4}$',
                    eg: 'SE1 0SU',
                },
            },
        ],
        name: 'United Kingdom',
    },
    {
        iso: 'UM',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'ZIP Code' } }],
        name: 'United States Minor Outlying Islands',
    },
    {
        iso: 'UY',
        phone: '598',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Department',
                    options: [
                        { AA: 'Artigas' },
                        { AA: 'Canelones' },
                        { AA: 'Cerro Largo' },
                        { AA: 'Colonia' },
                        { AA: 'Durazno' },
                        { AA: 'Flores' },
                        { AA: 'Florida' },
                        { AA: 'Lavalleja' },
                        { AA: 'Maldonado' },
                        { AA: 'Montevideo' },
                        { AA: 'Paysandú' },
                        { AA: 'Río Negro' },
                        { AA: 'Rivera' },
                        { AA: 'Rocha' },
                        { AA: 'Salto' },
                        { AA: 'San José' },
                        { AA: 'Soriano' },
                        { AA: 'Tacuarembó' },
                        { AA: 'Treinta y Tres' },
                    ],
                },
            },
        ],
        name: 'Uruguay',
    },
    {
        iso: 'UZ',
        phone: '998',
        address: [{ localityname: { label: 'City' } }, { postalcode: { label: 'Postal Code' } }],
        name: 'Uzbekistan',
    },
    {
        iso: 'VU',
        phone: '678',
        address: [{ localityname: { label: 'City' } }],
        name: 'Vanuatu',
    },
    {
        iso: 'VA',
        phone: '39',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Vatican',
    },
    {
        iso: 'VE',
        phone: '58',
        address: [
            { postalcode: { label: 'Postal Code' } },
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'State',
                    options: [
                        { Z: 'Amazonas' },
                        { B: 'Anzoátegui' },
                        { C: 'Apure' },
                        { D: 'Aragua' },
                        { E: 'Barinas' },
                        { F: 'Bolívar' },
                        { G: 'Carabobo' },
                        { H: 'Cojedes' },
                        { Y: 'Delta Amacuro' },
                        { W: 'Dependencias Federales' },
                        { A: 'Distrito Federal' },
                        { I: 'Falcón' },
                        { J: 'Guárico' },
                        { K: 'Lara' },
                        { L: 'Mérida' },
                        { M: 'Miranda' },
                        { N: 'Monagas' },
                        { O: 'Nueva Esparta' },
                        { P: 'Portuguesa' },
                        { R: 'Sucre' },
                        { S: 'Táchira' },
                        { T: 'Trujillo' },
                        { X: 'Vargas' },
                        { U: 'Yaracuy' },
                        { V: 'Zulia' },
                    ],
                },
            },
        ],
        name: 'Venezuela',
    },
    {
        iso: 'VN',
        phone: '84',
        address: [
            { localityname: { label: 'City' } },
            {
                administrativearea: {
                    label: 'Province',
                    options: [
                        { AA: 'Bắc Giang' },
                        { AA: 'Bắc Kạn' },
                        { AA: 'Cao Bằng' },
                        { AA: 'Hà Giang' },
                        { AA: 'Lạng Sơn' },
                        { AA: 'Phú Thọ' },
                        { AA: 'Quảng Ninh' },
                        { AA: 'Thái Nguyên' },
                        { AA: 'Tuyên Quang' },
                        { AA: 'Lào Cai' },
                        { AA: 'Yên Bái' },
                        { AA: 'Điện Biên' },
                        { AA: 'Hòa Bình' },
                        { AA: 'Lai Châu' },
                        { AA: 'Sơn La' },
                        { AA: 'Bắc Ninh' },
                        { AA: 'Hà Nam' },
                        { AA: 'Hải Dương' },
                        { AA: 'Hưng Yên' },
                        { AA: 'Nam Định' },
                        { AA: 'Ninh Bình' },
                        { AA: 'Thái Bình' },
                        { AA: 'Vĩnh Phúc' },
                        { AA: 'Hà Nội City' },
                        { AA: 'Hải Phòng City' },
                        { AA: 'Hà Tĩnh' },
                        { AA: 'Nghệ An' },
                        { AA: 'Quảng Bình' },
                        { AA: 'Quảng Trị' },
                        { AA: 'Thanh Hóa' },
                        { AA: 'Thừa Thiên–Huế' },
                        { AA: 'Đắk Lắk' },
                        { AA: 'Đắk Nông' },
                        { AA: 'Gia Lai' },
                        { AA: 'Kon Tum' },
                        { AA: 'Lâm Đồng' },
                        { AA: 'Bình Định' },
                        { AA: 'Bình Thuận' },
                        { AA: 'Khánh Hòa' },
                        { AA: 'Ninh Thuận' },
                        { AA: 'Phú Yên' },
                        { AA: 'Quảng Nam' },
                        { AA: 'Quảng Ngãi' },
                        { AA: 'Đà Nẵng City' },
                        { AA: 'Bà Rịa–Vũng Tàu' },
                        { AA: 'Bình Dương' },
                        { AA: 'Bình Phước' },
                        { AA: 'Đồng Nai' },
                        { AA: 'Tây Ninh' },
                        { AA: 'Hồ Chí Minh City' },
                        { AA: 'An Giang' },
                        { AA: 'Bạc Liêu' },
                        { AA: 'Bến Tre' },
                        { AA: 'Cà Mau' },
                        { AA: 'Đồng Tháp' },
                        { AA: 'Hậu Giang' },
                        { AA: 'Kiên Giang' },
                        { AA: 'Long An' },
                        { AA: 'Sóc Trăng' },
                        { AA: 'Tiền Giang' },
                        { AA: 'Trà Vinh' },
                        { AA: 'Vĩnh Long' },
                        { AA: 'Cần Thơ City' },
                    ],
                },
            },
            { postalcode: { label: 'Postal Code' } },
        ],
        name: 'Vietnam',
    },
    {
        iso: 'WF',
        phone: '681',
        address: [
            {
                postalcode: {
                    label: 'Postal Code',
                    format: '^986\\d{2}$',
                    eg: '98600',
                },
            },
            { localityname: { label: 'City' } },
        ],
        name: 'Wallis and Futuna',
    },
    {
        iso: 'EH',
        phone: '212',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Western Sahara',
    },
    {
        iso: 'YE',
        phone: '967',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Yemen',
    },
    {
        iso: 'ZM',
        phone: '260',
        address: [{ postalcode: { label: 'Postal Code' } }, { localityname: { label: 'City' } }],
        name: 'Zambia',
    },
    {
        iso: 'ZW',
        phone: '263',
        address: [{ localityname: { label: 'City' } }],
        name: 'Zimbabwe',
    },
];
